export const dataArray = [{"key":"loc_eesti","name":"Eesti","count":95},{"key":"loc_tallinn","name":"Tallinn","count":41},{"key":"loc_soome","name":"Soome","count":19},{"key":"loc_moskva","name":"Moskva","count":19},{"key":"loc_ameerika","name":"Ameerika","count":15},{"key":"loc_nõukogude_liit","name":"Nõukogude Liit","count":12},{"key":"loc_eesti_vabariik","name":"Eesti Vabariik","count":11},{"key":"loc_venemaa","name":"Venemaa","count":11},{"key":"loc_euroopa","name":"Euroopa","count":10},{"key":"loc_pärnu","name":"Pärnu","count":10},{"key":"loc_tartu","name":"Tartu","count":10},{"key":"loc_saaremaa","name":"Saaremaa","count":10},{"key":"loc_saksamaa","name":"Saksamaa","count":9},{"key":"loc_lasnamäe","name":"Lasnamäe","count":8},{"key":"loc_poola","name":"Poola","count":7},{"key":"loc_viljandi","name":"Viljandi","count":7},{"key":"loc_norra","name":"Norra","count":7},{"key":"loc_eesti_riik","name":"Eesti Riik","count":6},{"key":"loc_eestimaa","name":"Eestimaa","count":6},{"key":"loc_taani","name":"Taani","count":6},{"key":"loc_haapsalu","name":"Haapsalu","count":5},{"key":"loc_rootsi","name":"Rootsi","count":5},{"key":"loc_inglismaa","name":"Inglismaa","count":5},{"key":"loc_läti","name":"Läti","count":4},{"key":"loc_pariis","name":"Pariis","count":4},{"key":"loc_pirita","name":"Pirita","count":4},{"key":"loc_belgia","name":"Belgia","count":4},{"key":"loc_hiina","name":"Hiina","count":4},{"key":"loc_london","name":"London","count":4},{"key":"loc_hispaania","name":"Hispaania","count":3},{"key":"loc_rapla","name":"Rapla","count":3},{"key":"loc_türi","name":"Türi","count":3},{"key":"loc_viru","name":"Viru","count":3},{"key":"loc_holland","name":"Holland","count":3},{"key":"loc_itaalia","name":"Itaalia","count":3},{"key":"loc_jõgeval","name":"Jõgeval","count":3},{"key":"loc_leedu","name":"Leedu","count":3},{"key":"loc_gruusia","name":"Gruusia","count":3},{"key":"loc_india","name":"India","count":3},{"key":"loc_narva","name":"Narva","count":3},{"key":"loc_baltikum","name":"Baltikum","count":3},{"key":"loc_berliin","name":"Berliin","count":3},{"key":"loc_leningrad","name":"Leningrad","count":3},{"key":"loc_siber","name":"Siber","count":3},{"key":"loc_põlva","name":"Põlva","count":2},{"key":"loc_võrumaa","name":"Võrumaa","count":2},{"key":"loc_brüssel","name":"Brüssel","count":2},{"key":"loc_iisrael","name":"Iisrael","count":2},{"key":"loc_raplamaa","name":"Raplamaa","count":2},{"key":"loc_toompea","name":"Toompea","count":2},{"key":"loc_ülemiste","name":"Ülemiste","count":2},{"key":"loc_austraalia","name":"Austraalia","count":2},{"key":"loc_horvaatia","name":"Horvaatia","count":2},{"key":"loc_nõmme","name":"Nõmme","count":2},{"key":"loc_põhjamaa","name":"Põhjamaa","count":2},{"key":"loc_pöögelmann","name":"Pöögelmann","count":2},{"key":"loc_riia","name":"Riia","count":2},{"key":"loc_jaapan","name":"Jaapan","count":2},{"key":"loc_jõhvi","name":"Jõhvi","count":2},{"key":"loc_keila","name":"Keila","count":2},{"key":"loc_kihnu","name":"Kihnu","count":2},{"key":"loc_kreeka","name":"Kreeka","count":2},{"key":"loc_new_york","name":"New York","count":2},{"key":"loc_paldiski","name":"Paldiski","count":2},{"key":"loc_prantsusmaa","name":"Prantsusmaa","count":2},{"key":"loc_rakvere","name":"Rakvere","count":2},{"key":"loc_washington","name":"Washington","count":2},{"key":"loc_šveits","name":"Šveits","count":2},{"key":"loc_altmets","name":"Altmets","count":1},{"key":"loc_ameerika_ühendriik","name":"Ameerika Ühendriik","count":1},{"key":"loc_ateena","name":"Ateena","count":1},{"key":"loc_balti_riik","name":"Balti Riik","count":1},{"key":"loc_brasiilia","name":"Brasiilia","count":1},{"key":"loc_cotton","name":"Cotton","count":1},{"key":"loc_ecuador","name":"Ecuador","count":1},{"key":"loc_emajõe","name":"Emajõe","count":1},{"key":"loc_genf","name":"Genf","count":1},{"key":"loc_iirimaa","name":"Iirimaa","count":1},{"key":"loc_india_jiang","name":"India Jiang","count":1},{"key":"loc_istanbul","name":"Istanbul","count":1},{"key":"loc_jeruusalemma","name":"Jeruusalemma","count":1},{"key":"loc_jürk","name":"Jürk","count":1},{"key":"loc_kalamaja","name":"Kalamaja","count":1},{"key":"loc_keila_linn","name":"Keila Linn","count":1},{"key":"loc_kihnu_saar","name":"Kihnu Saar","count":1},{"key":"loc_koeru","name":"Koeru","count":1},{"key":"loc_kõrvemaa","name":"Kõrvemaa","count":1},{"key":"loc_kristiine","name":"Kristiine","count":1},{"key":"loc_kuusalu","name":"Kuusalu","count":1},{"key":"loc_leebe_küla","name":"Leebe Küla","count":1},{"key":"loc_lihula","name":"Lihula","count":1},{"key":"loc_liivimaa","name":"Liivimaa","count":1},{"key":"loc_marss","name":"Marss","count":1},{"key":"loc_mere_puiestee","name":"Mere Puiestee","count":1},{"key":"loc_monteeriana","name":"Monteeriana","count":1},{"key":"loc_muhu_saar","name":"Muhu Saar","count":1},{"key":"loc_märjamaa","name":"Märjamaa","count":1},{"key":"loc_niguline","name":"Niguline","count":1},{"key":"loc_nõukogude_hollywood","name":"Nõukogude Hollywood","count":1},{"key":"loc_padi","name":"Padi","count":1},{"key":"loc_saare-lääne","name":"Saare-lääne","count":1},{"key":"loc_saksa","name":"Saksa","count":1},{"key":"loc_singapur","name":"Singapur","count":1},{"key":"loc_stort","name":"Stort","count":1},{"key":"loc_taanimaa","name":"Taanimaa","count":1},{"key":"loc_tallinna_kesklinn","name":"Tallinna Kesklinn","count":1},{"key":"loc_tondi","name":"Tondi","count":1},{"key":"loc_torni_küla","name":"Torni Küla","count":1},{"key":"loc_usa","name":"Usa","count":1},{"key":"loc_vastseliina","name":"Vastseliina","count":1},{"key":"loc_viimsi","name":"Viimsi","count":1},{"key":"loc_windon","name":"Windon","count":1},{"key":"loc_aafrika","name":"Aafrika","count":1},{"key":"loc_altoni","name":"Altoni","count":1},{"key":"loc_amsterdam","name":"Amsterdam","count":1},{"key":"loc_audrus","name":"Audrus","count":1},{"key":"loc_barcelon","name":"Barcelon","count":1},{"key":"loc_dilberdas","name":"Dilberdas","count":1},{"key":"loc_emajõgi","name":"Emajõgi","count":1},{"key":"loc_euroopa_maa","name":"Euroopa Maa","count":1},{"key":"loc_gorbatšov","name":"Gorbatšov","count":1},{"key":"loc_harju","name":"Harju","count":1},{"key":"loc_kaarli","name":"Kaarli","count":1},{"key":"loc_kanada","name":"Kanada","count":1},{"key":"loc_kesk-eesti","name":"Kesk-eesti","count":1},{"key":"loc_kiiev","name":"Kiiev","count":1},{"key":"loc_kopli","name":"Kopli","count":1},{"key":"loc_kose","name":"Kose","count":1},{"key":"loc_kurdma","name":"Kurdma","count":1},{"key":"loc_ladina-ameerika","name":"Ladina-ameerika","count":1},{"key":"loc_lihula_vald","name":"Lihula Vald","count":1},{"key":"loc_lissabon","name":"Lissabon","count":1},{"key":"loc_läänemaa","name":"Läänemaa","count":1},{"key":"loc_matsalu","name":"Matsalu","count":1},{"key":"loc_metsküla","name":"Metsküla","count":1},{"key":"loc_monteerima","name":"Monteerima","count":1},{"key":"loc_mustamäe","name":"Mustamäe","count":1},{"key":"loc_nagunii","name":"Nagunii","count":1},{"key":"loc_nizza","name":"Nizza","count":1},{"key":"loc_paide","name":"Paide","count":1},{"key":"loc_parmas","name":"Parmas","count":1},{"key":"loc_põhja-eesti","name":"Põhja-eesti","count":1},{"key":"loc_pöidla","name":"Pöidla","count":1},{"key":"loc_rubla","name":"Rubla","count":1},{"key":"loc_supoljansk","name":"Supoljansk","count":1},{"key":"loc_tabasalu","name":"Tabasalu","count":1},{"key":"loc_tallinna_linn","name":"Tallinna Linn","count":1},{"key":"loc_tartumaa","name":"Tartumaa","count":1},{"key":"loc_torontos","name":"Torontos","count":1},{"key":"loc_tüüri","name":"Tüüri","count":1},{"key":"loc_vaivara","name":"Vaivara","count":1},{"key":"loc_veneetsia","name":"Veneetsia","count":1},{"key":"loc_volga","name":"Volga","count":1},{"key":"loc_värska","name":"Värska","count":1},{"key":"loc_aasia","name":"Aasia","count":1},{"key":"loc_amazon","name":"Amazon","count":1},{"key":"loc_antsu","name":"Antsu","count":1},{"key":"loc_bukarest","name":"Bukarest","count":1},{"key":"loc_donskatus","name":"Donskatus","count":1},{"key":"loc_elva","name":"Elva","count":1},{"key":"loc_essaugum","name":"Essaugum","count":1},{"key":"loc_freemia","name":"Freemia","count":1},{"key":"loc_iraak","name":"Iraak","count":1},{"key":"loc_itaalia_saar","name":"Itaalia Saar","count":1},{"key":"loc_jõhv","name":"Jõhv","count":1},{"key":"loc_kaarma","name":"Kaarma","count":1},{"key":"loc_karksi-nuia","name":"Karksi-nuia","count":1},{"key":"loc_ketšup","name":"Ketšup","count":1},{"key":"loc_kingissepa","name":"Kingissepa","count":1},{"key":"loc_koplis","name":"Koplis","count":1},{"key":"loc_kosovo","name":"Kosovo","count":1},{"key":"loc_kuressaare","name":"Kuressaare","count":1},{"key":"loc_lembiaamia","name":"Lembiaamia","count":1},{"key":"loc_liibanon","name":"Liibanon","count":1},{"key":"loc_mahtra","name":"Mahtra","count":1},{"key":"loc_matsalu_rahvuspark","name":"Matsalu Rahvuspark","count":1},{"key":"loc_mexico_citys","name":"Mexico Citys","count":1},{"key":"loc_monteeris","name":"Monteeris","count":1},{"key":"loc_mustamäe_emo","name":"Mustamäe Emo","count":1},{"key":"loc_nõukogude_maailm","name":"Nõukogude Maailm","count":1},{"key":"loc_paie","name":"Paie","count":1},{"key":"loc_pikamaa","name":"Pikamaa","count":1},{"key":"loc_portugal","name":"Portugal","count":1},{"key":"loc_rumeenia","name":"Rumeenia","count":1},{"key":"loc_saina","name":"Saina","count":1},{"key":"loc_seejärel","name":"Seejärel","count":1},{"key":"loc_sosmondlaslannantaažija","name":"Sosmondlaslannantaažija","count":1},{"key":"loc_suurbritannia","name":"Suurbritannia","count":1},{"key":"loc_tais","name":"Tais","count":1},{"key":"loc_tallinn_helsingi","name":"Tallinn Helsingi","count":1},{"key":"loc_tartu_linn","name":"Tartu Linn","count":1},{"key":"loc_toris","name":"Toris","count":1},{"key":"loc_tõrva","name":"Tõrva","count":1},{"key":"loc_tšetšeenia","name":"Tšetšeenia","count":1},{"key":"loc_valga","name":"Valga","count":1},{"key":"loc_vilsandi_saar","name":"Vilsandi Saar","count":1},{"key":"loc_vormsi","name":"Vormsi","count":1},{"key":"loc_vääna","name":"Vääna","count":1},{"key":"loc_ärgoit","name":"Ärgoit","count":1},{"key":"loc_afganistan","name":"Afganistan","count":1},{"key":"loc_armeenia","name":"Armeenia","count":1},{"key":"loc_california","name":"California","count":1},{"key":"loc_džaul","name":"Džaul","count":1},{"key":"loc_eesti_nsv","name":"Eesti Nsv","count":1},{"key":"loc_elysee","name":"Elysee","count":1},{"key":"loc_estonian","name":"Estonian","count":1},{"key":"loc_gazprom","name":"Gazprom","count":1},{"key":"loc_haapsald","name":"Haapsald","count":1},{"key":"loc_hiiumaa","name":"Hiiumaa","count":1},{"key":"loc_ida-euroopa","name":"Ida-euroopa","count":1},{"key":"loc_indiaan","name":"Indiaan","count":1},{"key":"loc_iraan","name":"Iraan","count":1},{"key":"loc_kaks","name":"Kaks","count":1},{"key":"loc_kiviõli","name":"Kiviõli","count":1},{"key":"loc_kõrval","name":"Kõrval","count":1},{"key":"loc_kuusald","name":"Kuusald","count":1},{"key":"loc_lavka","name":"Lavka","count":1},{"key":"loc_liibüa","name":"Liibüa","count":1},{"key":"loc_lubama","name":"Lubama","count":1},{"key":"loc_maroko","name":"Maroko","count":1},{"key":"loc_mehhiko","name":"Mehhiko","count":1},{"key":"loc_minsk","name":"Minsk","count":1},{"key":"loc_must_meri","name":"Must Meri","count":1},{"key":"loc_odessa","name":"Odessa","count":1},{"key":"loc_pika_hermanni","name":"Pika Hermanni","count":1},{"key":"loc_põltsamaa","name":"Põltsamaa","count":1},{"key":"loc_rooma","name":"Rooma","count":1},{"key":"loc_räpina","name":"Räpina","count":1},{"key":"loc_sakala","name":"Sakala","count":1},{"key":"loc_stockholm","name":"Stockholm","count":1},{"key":"loc_tapa","name":"Tapa","count":1},{"key":"loc_tema","name":"Tema","count":1},{"key":"loc_torn","name":"Torn","count":1},{"key":"loc_tosso","name":"Tosso","count":1},{"key":"loc_ukraina","name":"Ukraina","count":1},{"key":"loc_valgusmaa","name":"Valgusmaa","count":1},{"key":"loc_vigala","name":"Vigala","count":1},{"key":"loc_virtsu","name":"Virtsu","count":1},{"key":"loc_võrtsjärv","name":"Võrtsjärv","count":1},{"key":"org_tallinnfilm","name":"Tallinnfilm","count":13},{"key":"org_tallinn","name":"Tallinn","count":10},{"key":"org_tallinn_film","name":"Tallinn Film","count":7},{"key":"org_eesti","name":"Eesti","count":7},{"key":"org_tartu_ülikool","name":"Tartu Ülikool","count":6},{"key":"org_tallinna_ülikool","name":"Tallinna Ülikool","count":5},{"key":"org_eesti_televisioon","name":"Eesti Televisioon","count":4},{"key":"org_err","name":"Err","count":3},{"key":"org_eesti_film","name":"Eesti Film","count":3},{"key":"org_estonia","name":"Estonia","count":3},{"key":"org_eesti_filmi_instituut","name":"Eesti Filmi Instituut","count":2},{"key":"org_raadio_kaks","name":"Raadio Kaks","count":2},{"key":"org_rimi","name":"Rimi","count":2},{"key":"org_twitter","name":"Twitter","count":2},{"key":"org_eesti_valitsus","name":"Eesti Valitsus","count":2},{"key":"org_etv","name":"Etv","count":2},{"key":"org_instagram","name":"Instagram","count":2},{"key":"org_eesti_raadio","name":"Eesti Raadio","count":2},{"key":"org_westholmi_gümnaasium","name":"Westholmi Gümnaasium","count":2},{"key":"org_bfm","name":"Bfm","count":2},{"key":"org_peda","name":"Peda","count":2},{"key":"org_baumani_tehas","name":"Baumani Tehas","count":1},{"key":"org_coca-cola","name":"Coca-cola","count":1},{"key":"org_diplomaatia","name":"Diplomaatia","count":1},{"key":"org_elisa","name":"Elisa","count":1},{"key":"org_ep","name":"Ep","count":1},{"key":"org_estonian_saar","name":"Estonian Saar","count":1},{"key":"org_gpu","name":"Gpu","count":1},{"key":"org_ilumäe_kolhoos","name":"Ilumäe Kolhoos","count":1},{"key":"org_kihnu_kool","name":"Kihnu Kool","count":1},{"key":"org_kreml","name":"Kreml","count":1},{"key":"org_lihula_vallavalitsus","name":"Lihula Vallavalitsus","count":1},{"key":"org_maaleht","name":"Maaleht","count":1},{"key":"org_moskva_televisioon","name":"Moskva Televisioon","count":1},{"key":"org_nato","name":"Nato","count":1},{"key":"org_pirita_klooster","name":"Pirita Klooster","count":1},{"key":"org_päevaleht","name":"Päevaleht","count":1},{"key":"org_tallinna_kinostuudio","name":"Tallinna Kinostuudio","count":1},{"key":"org_tallinna_sidekool","name":"Tallinna Sidekool","count":1},{"key":"org_teaduste_akadeemia","name":"Teaduste Akadeemia","count":1},{"key":"org_vene_sõjavägi","name":"Vene Sõjavägi","count":1},{"key":"org_volkswagen","name":"Volkswagen","count":1},{"key":"org_bbc_surnalistika","name":"Bbc Surnalistika","count":1},{"key":"org_coop_pank","name":"Coop Pank","count":1},{"key":"org_eeeffi","name":"Eeeffi","count":1},{"key":"org_eesti_kinokomitee","name":"Eesti Kinokomitee","count":1},{"key":"org_elo_rand","name":"Elo Rand","count":1},{"key":"org_haapsalu_kirik","name":"Haapsalu Kirik","count":1},{"key":"org_kik","name":"Kik","count":1},{"key":"org_kunstiteos","name":"Kunstiteos","count":1},{"key":"org_liivimaa_ord","name":"Liivimaa Ord","count":1},{"key":"org_metsküla_kool","name":"Metsküla Kool","count":1},{"key":"org_ms","name":"Ms","count":1},{"key":"org_nordea","name":"Nordea","count":1},{"key":"org_pirita_open","name":"Pirita Open","count":1},{"key":"org_pärnu_lade","name":"Pärnu Lade","count":1},{"key":"org_raasiku_haigla","name":"Raasiku Haigla","count":1},{"key":"org_soome_kompartei","name":"Soome Kompartei","count":1},{"key":"org_tallinna_kaarli_kirik","name":"Tallinna Kaarli Kirik","count":1},{"key":"org_tallinna_linnavalitsus","name":"Tallinna Linnavalitsus","count":1},{"key":"org_tallinna_tallinn_akadeemia","name":"Tallinna Tallinn Akadeemia","count":1},{"key":"org_top","name":"Top","count":1},{"key":"org_türi_keskkool","name":"Türi Keskkool","count":1},{"key":"org_vigala_maarja","name":"Vigala Maarja","count":1},{"key":"org_väimela_tehnikum","name":"Väimela Tehnikum","count":1},{"key":"org_belgia_ühiskond","name":"Belgia Ühiskond","count":1},{"key":"org_cv-online","name":"Cv-online","count":1},{"key":"org_eka","name":"Eka","count":1},{"key":"org_emex","name":"Emex","count":1},{"key":"org_erso","name":"Erso","count":1},{"key":"org_euroopa_kino","name":"Euroopa Kino","count":1},{"key":"org_hiv","name":"Hiv","count":1},{"key":"org_kaitseliit","name":"Kaitseliit","count":1},{"key":"org_kirjanike_liit","name":"Kirjanike Liit","count":1},{"key":"org_laagri_kool","name":"Laagri Kool","count":1},{"key":"org_line","name":"Line","count":1},{"key":"org_montaaž","name":"Montaaž","count":1},{"key":"org_mustpeade_maja","name":"Mustpeade Maja","count":1},{"key":"org_õhtuleht","name":"Õhtuleht","count":1},{"key":"org_politseiprefektuur","name":"Politseiprefektuur","count":1},{"key":"org_pärnu_muuseum","name":"Pärnu Muuseum","count":1},{"key":"org_rahvusooper_estonia","name":"Rahvusooper Estonia","count":1},{"key":"org_stockholmi_tehnikainstituut","name":"Stockholmi Tehnikainstituut","count":1},{"key":"org_tallinna_kesklinna_valitsus","name":"Tallinna Kesklinna Valitsus","count":1},{"key":"org_tallinna_reaalkool","name":"Tallinna Reaalkool","count":1},{"key":"org_tallinna_tehnikaülikool","name":"Tallinna Tehnikaülikool","count":1},{"key":"org_tartu","name":"Tartu","count":1},{"key":"org_tular","name":"Tular","count":1},{"key":"org_valgus","name":"Valgus","count":1},{"key":"org_vigala_maarja_kogudus","name":"Vigala Maarja Kogudus","count":1},{"key":"org_danske_pank","name":"Danske Pank","count":1},{"key":"org_eesti_telefilm","name":"Eesti Telefilm","count":1},{"key":"org_ekn","name":"Ekn","count":1},{"key":"org_emp","name":"Emp","count":1},{"key":"org_euroopa_liit","name":"Euroopa Liit","count":1},{"key":"org_hong_travel","name":"Hong Travel","count":1},{"key":"org_kaks","name":"Kaks","count":1},{"key":"org_kolga_kool","name":"Kolga Kool","count":1},{"key":"org_lihula_kool","name":"Lihula Kool","count":1},{"key":"org_lutsukomm","name":"Lutsukomm","count":1},{"key":"org_moskva_kinokool","name":"Moskva Kinokool","count":1},{"key":"org_napol","name":"Napol","count":1},{"key":"org_pro","name":"Pro","count":1},{"key":"org_pöff","name":"Pöff","count":1},{"key":"org_rakvere_tarbijate","name":"Rakvere Tarbijate","count":1},{"key":"org_tallink","name":"Tallink","count":1},{"key":"org_tallinna_kino","name":"Tallinna Kino","count":1},{"key":"org_tallinna_riiklik","name":"Tallinna Riiklik","count":1},{"key":"org_tulevik","name":"Tulevik","count":1},{"key":"org_vangla","name":"Vangla","count":1},{"key":"org_viljandi_kultuuriakadeemia","name":"Viljandi Kultuuriakadeemia","count":1},{"key":"org_ülemiste_keskus","name":"Ülemiste Keskus","count":1},{"key":"per_maria","name":"Maria","count":7},{"key":"per_karl","name":"Karl","count":6},{"key":"per_paul","name":"Paul","count":5},{"key":"per_jeesus","name":"Jeesus","count":4},{"key":"per_johannes","name":"Johannes","count":4},{"key":"per_andrei","name":"Andrei","count":4},{"key":"per_harry","name":"Harry","count":4},{"key":"per_maarja","name":"Maarja","count":4},{"key":"per_mark_soosaar","name":"Mark Soosaar","count":4},{"key":"per_alex","name":"Alex","count":3},{"key":"per_laura","name":"Laura","count":3},{"key":"per_leida_laius","name":"Leida Laius","count":3},{"key":"per_mark","name":"Mark","count":3},{"key":"per_peeter_tooming","name":"Peeter Tooming","count":3},{"key":"per_ise","name":"Ise","count":2},{"key":"per_kaspar","name":"Kaspar","count":2},{"key":"per_mart_otsa","name":"Mart Otsa","count":2},{"key":"per_sõber","name":"Sõber","count":2},{"key":"per_andres_sööt","name":"Andres Sööt","count":2},{"key":"per_jakob","name":"Jakob","count":2},{"key":"per_sofi","name":"Sofi","count":2},{"key":"per_valeria_anderson","name":"Valeria Anderson","count":2},{"key":"per_anton","name":"Anton","count":2},{"key":"per_arvo_iho","name":"Arvo Iho","count":2},{"key":"per_mait_mäekivi","name":"Mait Mäekivi","count":2},{"key":"per_mati_kask","name":"Mati Kask","count":2},{"key":"per_taivo_denso","name":"Taivo Denso","count":2},{"key":"per_aleksander","name":"Aleksander","count":2},{"key":"per_barbara","name":"Barbara","count":2},{"key":"per_kaljo_kiisk","name":"Kaljo Kiisk","count":2},{"key":"per_kelly","name":"Kelly","count":2},{"key":"per_marie","name":"Marie","count":2},{"key":"per_mati_unt","name":"Mati Unt","count":2},{"key":"per_olema","name":"Olema","count":2},{"key":"per_peetrus","name":"Peetrus","count":2},{"key":"per_andrese","name":"Andrese","count":2},{"key":"per_härra_baumann","name":"Härra Baumann","count":1},{"key":"per_jaak_aus","name":"Jaak Aus","count":1},{"key":"per_jaan_tätte","name":"Jaan Tätte","count":1},{"key":"per_jeesu","name":"Jeesu","count":1},{"key":"per_joachter","name":"Joachter","count":1},{"key":"per_joonas_loit","name":"Joonas Loit","count":1},{"key":"per_jumala_raids","name":"Jumala Raids","count":1},{"key":"per_jüri_mängufilm","name":"Jüri Mängufilm","count":1},{"key":"per_jäär","name":"Jäär","count":1},{"key":"per_kadina","name":"Kadina","count":1},{"key":"per_kaido","name":"Kaido","count":1},{"key":"per_kalmer_tennosaar","name":"Kalmer Tennosaar","count":1},{"key":"per_kerdama","name":"Kerdama","count":1},{"key":"per_kimi_räikkönen","name":"Kimi Räikkönen","count":1},{"key":"per_kolli_sten","name":"Kolli Sten","count":1},{"key":"per_kristel_aaslaid","name":"Kristel Aaslaid","count":1},{"key":"per_kukkonde","name":"Kukkonde","count":1},{"key":"per_langipar","name":"Langipar","count":1},{"key":"per_lesk","name":"Lesk","count":1},{"key":"per_linda_rummo","name":"Linda Rummo","count":1},{"key":"per_luitsa","name":"Luitsa","count":1},{"key":"per_madis_veldman","name":"Madis Veldman","count":1},{"key":"per_manto","name":"Manto","count":1},{"key":"per_mari-liis","name":"Mari-liis","count":1},{"key":"per_maria_ardo","name":"Maria Ardo","count":1},{"key":"per_marika_reintam","name":"Marika Reintam","count":1},{"key":"per_martin_helme","name":"Martin Helme","count":1},{"key":"per_mattias_naan","name":"Mattias Naan","count":1},{"key":"per_metsvinthall","name":"Metsvinthall","count":1},{"key":"per_mikko_mägi","name":"Mikko Mägi","count":1},{"key":"per_mirtel_pohla","name":"Mirtel Pohla","count":1},{"key":"per_murrs","name":"Murrs","count":1},{"key":"per_nikita_sergejevitš","name":"Nikita Sergejevitš","count":1},{"key":"per_nõmmi","name":"Nõmmi","count":1},{"key":"per_orparvate","name":"Orparvate","count":1},{"key":"per_paul-eerik_rummo","name":"Paul-eerik Rummo","count":1},{"key":"per_peedu_ojamaa","name":"Peedu Ojamaa","count":1},{"key":"per_piia_frous","name":"Piia Frous","count":1},{"key":"per_porno","name":"Porno","count":1},{"key":"per_pušk","name":"Pušk","count":1},{"key":"per_raimond_kolga","name":"Raimond Kolga","count":1},{"key":"per_rando_pettai","name":"Rando Pettai","count":1},{"key":"per_reili_saar","name":"Reili Saar","count":1},{"key":"per_rein_maran","name":"Rein Maran","count":1},{"key":"per_rene_morr","name":"Rene Morr","count":1},{"key":"per_riinot","name":"Riinot","count":1},{"key":"per_roger","name":"Roger","count":1},{"key":"per_rummu_jüri","name":"Rummu Jüri","count":1},{"key":"per_saara","name":"Saara","count":1},{"key":"per_shell","name":"Shell","count":1},{"key":"per_sulev_mäeltsemees","name":"Sulev Mäeltsemees","count":1},{"key":"per_tanel","name":"Tanel","count":1},{"key":"per_tema","name":"Tema","count":1},{"key":"per_tiiu","name":"Tiiu","count":1},{"key":"per_tõnis_kask","name":"Tõnis Kask","count":1},{"key":"per_torove","name":"Torove","count":1},{"key":"per_tuuli_rand","name":"Tuuli Rand","count":1},{"key":"per_urmas_tamm","name":"Urmas Tamm","count":1},{"key":"per_vaisse","name":"Vaisse","count":1},{"key":"per_valentin_kuik","name":"Valentin Kuik","count":1},{"key":"per_viive_leol","name":"Viive Leol","count":1},{"key":"per_vladimir_luts","name":"Vladimir Luts","count":1},{"key":"per_walter","name":"Walter","count":1},{"key":"per_šamaan","name":"Šamaan","count":1},{"key":"per_aabel","name":"Aabel","count":1},{"key":"per_ago_ruus","name":"Ago Ruus","count":1},{"key":"per_albert_hermann","name":"Albert Hermann","count":1},{"key":"per_andrus_stop","name":"Andrus Stop","count":1},{"key":"per_anspartal","name":"Anspartal","count":1},{"key":"per_ants_jõgi","name":"Ants Jõgi","count":1},{"key":"per_artra","name":"Artra","count":1},{"key":"per_august_tsirk","name":"August Tsirk","count":1},{"key":"per_berg","name":"Berg","count":1},{"key":"per_birmakera","name":"Birmakera","count":1},{"key":"per_carl_juunior","name":"Carl Juunior","count":1},{"key":"per_czukai","name":"Czukai","count":1},{"key":"per_dior","name":"Dior","count":1},{"key":"per_edgar_savisaar","name":"Edgar Savisaar","count":1},{"key":"per_edward_munk","name":"Edward Munk","count":1},{"key":"per_eerik_roosta","name":"Eerik Roosta","count":1},{"key":"per_eino_parss","name":"Eino Parss","count":1},{"key":"per_emil_rutiku","name":"Emil Rutiku","count":1},{"key":"per_enn_olev","name":"Enn Olev","count":1},{"key":"per_evald_hermaküla","name":"Evald Hermaküla","count":1},{"key":"per_gabriella_farrita","name":"Gabriella Farrita","count":1},{"key":"per_halleib","name":"Halleib","count":1},{"key":"per_harakas","name":"Harakas","count":1},{"key":"per_hasart","name":"Hasart","count":1},{"key":"per_helen_raivo","name":"Helen Raivo","count":1},{"key":"per_herbert_tul","name":"Herbert Tul","count":1},{"key":"per_ilter","name":"Ilter","count":1},{"key":"per_ivandratšov","name":"Ivandratšov","count":1},{"key":"per_jaan_kolbr","name":"Jaan Kolbr","count":1},{"key":"per_joosep_kristjan","name":"Joosep Kristjan","count":1},{"key":"per_jürgen_ligi","name":"Jürgen Ligi","count":1},{"key":"per_jüri_saar","name":"Jüri Saar","count":1},{"key":"per_kaamer","name":"Kaamer","count":1},{"key":"per_kadi_mats","name":"Kadi Mats","count":1},{"key":"per_kaisa_laos","name":"Kaisa Laos","count":1},{"key":"per_kapler","name":"Kapler","count":1},{"key":"per_katorajad","name":"Katorajad","count":1},{"key":"per_kihvt","name":"Kihvt","count":1},{"key":"per_kingsepa","name":"Kingsepa","count":1},{"key":"per_konstantin_päts","name":"Konstantin Päts","count":1},{"key":"per_kristiina","name":"Kristiina","count":1},{"key":"per_kuskil","name":"Kuskil","count":1},{"key":"per_lietuvos","name":"Lietuvos","count":1},{"key":"per_loll","name":"Loll","count":1},{"key":"per_luther_mattiisen","name":"Luther Mattiisen","count":1},{"key":"per_maimi_kilm","name":"Maimi Kilm","count":1},{"key":"per_maretskaja","name":"Maretskaja","count":1},{"key":"per_mari-liis_jakobson","name":"Mari-liis Jakobson","count":1},{"key":"per_maria_laidoner","name":"Maria Laidoner","count":1},{"key":"per_mari_tamm","name":"Mari Tamm","count":1},{"key":"per_mart_helme","name":"Mart Helme","count":1},{"key":"per_mart_siimann","name":"Mart Siimann","count":1},{"key":"per_mcip","name":"Mcip","count":1},{"key":"per_mia","name":"Mia","count":1},{"key":"per_mikkus","name":"Mikkus","count":1},{"key":"per_mirty","name":"Mirty","count":1},{"key":"per_mäkidet","name":"Mäkidet","count":1},{"key":"per_nikolai","name":"Nikolai","count":1},{"key":"per_nornio","name":"Nornio","count":1},{"key":"per_otto","name":"Otto","count":1},{"key":"per_paul_mattiisen","name":"Paul Mattiisen","count":1},{"key":"per_peeter_simm","name":"Peeter Simm","count":1},{"key":"per_piia_roosi","name":"Piia Roosi","count":1},{"key":"per_pornovideode","name":"Pornovideode","count":1},{"key":"per_pärnika","name":"Pärnika","count":1},{"key":"per_raimond_tamm","name":"Raimond Tamm","count":1},{"key":"per_regina","name":"Regina","count":1},{"key":"per_reinhold_rotermanni","name":"Reinhold Rotermanni","count":1},{"key":"per_rein_raamat","name":"Rein Raamat","count":1},{"key":"per_rene_puura","name":"Rene Puura","count":1},{"key":"per_risto_puri","name":"Risto Puri","count":1},{"key":"per_roland_saagravu","name":"Roland Saagravu","count":1},{"key":"per_räägi-rääk","name":"Räägi-rääk","count":1},{"key":"per_sander_mölder","name":"Sander Mölder","count":1},{"key":"per_siiri_oviir","name":"Siiri Oviir","count":1},{"key":"per_sünge","name":"Sünge","count":1},{"key":"per_tapport","name":"Tapport","count":1},{"key":"per_tenkeš","name":"Tenkeš","count":1},{"key":"per_timbuling","name":"Timbuling","count":1},{"key":"per_tõnu_naissoo","name":"Tõnu Naissoo","count":1},{"key":"per_tuul","name":"Tuul","count":1},{"key":"per_tšekki","name":"Tšekki","count":1},{"key":"per_urvaka","name":"Urvaka","count":1},{"key":"per_valdemar","name":"Valdemar","count":1},{"key":"per_viivi_luik","name":"Viivi Luik","count":1},{"key":"per_vladimir_parvel","name":"Vladimir Parvel","count":1},{"key":"per_william","name":"William","count":1},{"key":"per_aare_tilk","name":"Aare Tilk","count":1},{"key":"per_aino_ene","name":"Aino Ene","count":1},{"key":"per_albert_tuganov","name":"Albert Tuganov","count":1},{"key":"per_andruse","name":"Andruse","count":1},{"key":"per_animal","name":"Animal","count":1},{"key":"per_ants_kaljurand","name":"Ants Kaljurand","count":1},{"key":"per_bach","name":"Bach","count":1},{"key":"per_bernard_kangro","name":"Bernard Kangro","count":1},{"key":"per_brunoga","name":"Brunoga","count":1},{"key":"per_chardonnay","name":"Chardonnay","count":1},{"key":"per_daša_otto","name":"Daša Otto","count":1},{"key":"per_dmitri","name":"Dmitri","count":1},{"key":"per_eduard_grenzstein","name":"Eduard Grenzstein","count":1},{"key":"per_eeriku","name":"Eeriku","count":1},{"key":"per_eeva_brown","name":"Eeva Brown","count":1},{"key":"per_elephants","name":"Elephants","count":1},{"key":"per_endel_pärn","name":"Endel Pärn","count":1},{"key":"per_erikurat","name":"Erikurat","count":1},{"key":"per_eve_kivi","name":"Eve Kivi","count":1},{"key":"per_grete_kaljuste","name":"Grete Kaljuste","count":1},{"key":"per_hannes_kaljujärv","name":"Hannes Kaljujärv","count":1},{"key":"per_heiki_ernits","name":"Heiki Ernits","count":1},{"key":"per_helen_vinogradov","name":"Helen Vinogradov","count":1},{"key":"per_herbert_tulp","name":"Herbert Tulp","count":1},{"key":"per_ingrid_ing","name":"Ingrid Ing","count":1},{"key":"per_ivan_puunima","name":"Ivan Puunima","count":1},{"key":"per_jaan_tasa","name":"Jaan Tasa","count":1},{"key":"per_janno_pipathanka","name":"Janno Pipathanka","count":1},{"key":"per_jekaterina_winaagratskaja","name":"Jekaterina Winaagratskaja","count":1},{"key":"per_johannes_vares-barbarus","name":"Johannes Vares-barbarus","count":1},{"key":"per_joosep_tamm","name":"Joosep Tamm","count":1},{"key":"per_jüril","name":"Jüril","count":1},{"key":"per_jüri_sillart","name":"Jüri Sillart","count":1},{"key":"per_kaamera","name":"Kaamera","count":1},{"key":"per_kadri_kanter","name":"Kadri Kanter","count":1},{"key":"per_kalfi","name":"Kalfi","count":1},{"key":"per_kaur_mägi","name":"Kaur Mägi","count":1},{"key":"per_kilekott","name":"Kilekott","count":1},{"key":"per_kino","name":"Kino","count":1},{"key":"per_kõrboja","name":"Kõrboja","count":1},{"key":"per_kristjan_mari","name":"Kristjan Mari","count":1},{"key":"per_kuskilt","name":"Kuskilt","count":1},{"key":"per_lietuvos_sostame","name":"Lietuvos Sostame","count":1},{"key":"per_loolaiper","name":"Loolaiper","count":1},{"key":"per_maalit","name":"Maalit","count":1},{"key":"per_maretzca","name":"Maretzca","count":1},{"key":"per_maria_norman","name":"Maria Norman","count":1},{"key":"per_mart_kessel","name":"Mart Kessel","count":1},{"key":"per_meelis_loovere","name":"Meelis Loovere","count":1},{"key":"per_michael_martin","name":"Michael Martin","count":1},{"key":"per_mikk_rand","name":"Mikk Rand","count":1},{"key":"per_mitta_aleksander","name":"Mitta Aleksander","count":1},{"key":"per_naatsaret","name":"Naatsaret","count":1},{"key":"per_nipernaad","name":"Nipernaad","count":1},{"key":"per_okova","name":"Okova","count":1},{"key":"per_pajusti","name":"Pajusti","count":1},{"key":"per_pavel_kubo","name":"Pavel Kubo","count":1},{"key":"per_pirete","name":"Pirete","count":1},{"key":"per_priit_pärn","name":"Priit Pärn","count":1},{"key":"per_rabak","name":"Rabak","count":1},{"key":"per_rain_simmul","name":"Rain Simmul","count":1},{"key":"per_regina_meri","name":"Regina Meri","count":1},{"key":"per_rein_kootu","name":"Rein Kootu","count":1},{"key":"per_remurd","name":"Remurd","count":1},{"key":"per_revo","name":"Revo","count":1},{"key":"per_robert_kas","name":"Robert Kas","count":1},{"key":"per_ron","name":"Ron","count":1},{"key":"per_rääkima","name":"Rääkima","count":1},{"key":"per_sandra","name":"Sandra","count":1},{"key":"per_siljardül","name":"Siljardül","count":1},{"key":"per_stefan","name":"Stefan","count":1},{"key":"per_taylor","name":"Taylor","count":1},{"key":"per_terje_talv","name":"Terje Talv","count":1},{"key":"per_toivo_helme","name":"Toivo Helme","count":1},{"key":"per_tõnu_virve","name":"Tõnu Virve","count":1},{"key":"per_tuuline","name":"Tuuline","count":1},{"key":"per_uku_masing","name":"Uku Masing","count":1},{"key":"per_urve_palo","name":"Urve Palo","count":1},{"key":"per_valdemar_ist","name":"Valdemar Ist","count":1},{"key":"per_vasak","name":"Vasak","count":1},{"key":"per_virv","name":"Virv","count":1},{"key":"per_voldemar_jänes","name":"Voldemar Jänes","count":1},{"key":"per_ülo_tambek","name":"Ülo Tambek","count":1},{"key":"per_adolf_hitler","name":"Adolf Hitler","count":1},{"key":"per_aitäh","name":"Aitäh","count":1},{"key":"per_andrei_tarkovski","name":"Andrei Tarkovski","count":1},{"key":"per_andrus_ansip","name":"Andrus Ansip","count":1},{"key":"per_anna-brita","name":"Anna-brita","count":1},{"key":"per_anton_hansen","name":"Anton Hansen","count":1},{"key":"per_ants_park","name":"Ants Park","count":1},{"key":"per_arvo_kukumägi","name":"Arvo Kukumägi","count":1},{"key":"per_betti_alver","name":"Betti Alver","count":1},{"key":"per_bruno_limbak","name":"Bruno Limbak","count":1},{"key":"per_children","name":"Children","count":1},{"key":"per_dennis_potter","name":"Dennis Potter","count":1},{"key":"per_dmitri_mattiis","name":"Dmitri Mattiis","count":1},{"key":"per_edward","name":"Edward","count":1},{"key":"per_eerik_kruus","name":"Eerik Kruus","count":1},{"key":"per_eevi_silla","name":"Eevi Silla","count":1},{"key":"per_elite","name":"Elite","count":1},{"key":"per_endel_rita","name":"Endel Rita","count":1},{"key":"per_ester_väljaots","name":"Ester Väljaots","count":1},{"key":"per_fengher","name":"Fengher","count":1},{"key":"per_grimmide","name":"Grimmide","count":1},{"key":"per_hannes_võrno","name":"Hannes Võrno","count":1},{"key":"per_harry_martinson","name":"Harry Martinson","count":1},{"key":"per_heino_pars","name":"Heino Pars","count":1},{"key":"per_helmi","name":"Helmi","count":1},{"key":"per_hildsoff","name":"Hildsoff","count":1},{"key":"per_ira","name":"Ira","count":1},{"key":"per_ivo_linna","name":"Ivo Linna","count":1},{"key":"per_jaan_toominga","name":"Jaan Toominga","count":1},{"key":"per_jan_uus","name":"Jan Uus","count":1},{"key":"per_jevgeni_hirmoonia","name":"Jevgeni Hirmoonia","count":1},{"key":"per_john_jean","name":"John Jean","count":1},{"key":"per_juhan","name":"Juhan","count":1},{"key":"per_jüri_müür","name":"Jüri Müür","count":1},{"key":"per_jüri_sillarta","name":"Jüri Sillarta","count":1},{"key":"per_kaarel_kurismaa","name":"Kaarel Kurismaa","count":1},{"key":"per_kadri_karu","name":"Kadri Karu","count":1},{"key":"per_karl_markus","name":"Karl Markus","count":1},{"key":"per_kim","name":"Kim","count":1},{"key":"per_kirill","name":"Kirill","count":1},{"key":"per_kristel_aa","name":"Kristel Aa","count":1},{"key":"per_kristus","name":"Kristus","count":1},{"key":"per_laano","name":"Laano","count":1},{"key":"per_leis","name":"Leis","count":1},{"key":"per_limbul","name":"Limbul","count":1},{"key":"per_louis_kristo","name":"Louis Kristo","count":1},{"key":"per_mait_rufe","name":"Mait Rufe","count":1},{"key":"per_margus_tamme","name":"Margus Tamme","count":1},{"key":"per_maria_aleksei","name":"Maria Aleksei","count":1},{"key":"per_mart_laar","name":"Mart Laar","count":1},{"key":"per_merle_karusoo","name":"Merle Karusoo","count":1},{"key":"per_mihkel_anna-brita","name":"Mihkel Anna-brita","count":1},{"key":"per_mikk_sarv","name":"Mikk Sarv","count":1},{"key":"per_monika","name":"Monika","count":1},{"key":"per_nikita_michalkov","name":"Nikita Michalkov","count":1},{"key":"per_nipernaat","name":"Nipernaat","count":1},{"key":"per_peeaa","name":"Peeaa","count":1},{"key":"per_piret_kaljuste","name":"Piret Kaljuste","count":1},{"key":"per_puriood","name":"Puriood","count":1},{"key":"per_rail","name":"Rail","count":1},{"key":"per_raivo_maria","name":"Raivo Maria","count":1},{"key":"per_reija","name":"Reija","count":1},{"key":"per_rein_mara","name":"Rein Mara","count":1},{"key":"per_rene_haljas","name":"Rene Haljas","count":1},{"key":"per_riinat","name":"Riinat","count":1},{"key":"per_robert_kask","name":"Robert Kask","count":1},{"key":"per_ronaldo","name":"Ronaldo","count":1},{"key":"per_saagnemy","name":"Saagnemy","count":1},{"key":"per_sauvignon_blanc","name":"Sauvignon Blanc","count":1},{"key":"per_smilers","name":"Smilers","count":1},{"key":"per_sulev_keedus","name":"Sulev Keedus","count":1},{"key":"per_tamand_višnu","name":"Tamand Višnu","count":1},{"key":"per_teet_kallas","name":"Teet Kallas","count":1},{"key":"per_tiima","name":"Tiima","count":1},{"key":"per_tom_tamme","name":"Tom Tamme","count":1},{"key":"per_toomas_crumpa","name":"Toomas Crumpa","count":1},{"key":"per_tuuli_kool","name":"Tuuli Kool","count":1},{"key":"per_uno_naissoo","name":"Uno Naissoo","count":1},{"key":"per_vadja_jürkare","name":"Vadja Jürkare","count":1},{"key":"per_valentin","name":"Valentin","count":1},{"key":"per_vettumart","name":"Vettumart","count":1},{"key":"per_virve_reiman","name":"Virve Reiman","count":1},{"key":"per_vufa","name":"Vufa","count":1},{"key":"per_äkki","name":"Äkki","count":1},{"key":"per_adolf_test","name":"Adolf Test","count":1},{"key":"per_albert","name":"Albert","count":1},{"key":"per_aleksei_tony","name":"Aleksei Tony","count":1},{"key":"per_andrus_paavel","name":"Andrus Paavel","count":1},{"key":"per_anne_mere","name":"Anne Mere","count":1},{"key":"per_anton_hansen_tammsaare","name":"Anton Hansen Tammsaare","count":1},{"key":"per_arnold_luther","name":"Arnold Luther","count":1},{"key":"per_arvo_pärt","name":"Arvo Pärt","count":1},{"key":"per_beff","name":"Beff","count":1},{"key":"per_bhabai","name":"Bhabai","count":1},{"key":"per_bruno_noppanen","name":"Bruno Noppanen","count":1},{"key":"per_christopher_louis","name":"Christopher Louis","count":1},{"key":"per_dimitri_mattiisen","name":"Dimitri Mattiisen","count":1},{"key":"per_dmitri_mattiisen","name":"Dmitri Mattiisen","count":1},{"key":"per_edwardi","name":"Edwardi","count":1},{"key":"per_eerik_las","name":"Eerik Las","count":1},{"key":"per_eha_masing","name":"Eha Masing","count":1},{"key":"per_elo_rand","name":"Elo Rand","count":1},{"key":"per_endel_sven","name":"Endel Sven","count":1},{"key":"per_evald_aavik","name":"Evald Aavik","count":1},{"key":"per_ferik","name":"Ferik","count":1},{"key":"per_gustav","name":"Gustav","count":1},{"key":"per_hans","name":"Hans","count":1},{"key":"per_harry_rehe","name":"Harry Rehe","count":1},{"key":"per_helenal","name":"Helenal","count":1},{"key":"per_hendrik_sal-saller","name":"Hendrik Sal-saller","count":1},{"key":"per_hille_tarto","name":"Hille Tarto","count":1}]

export const keyPairs = {
  "loc_eesti": "Eesti",
  "loc_tallinn": "Tallinn",
  "loc_soome": "Soome",
  "loc_moskva": "Moskva",
  "loc_ameerika": "Ameerika",
  "loc_nõukogude_liit": "Nõukogude Liit",
  "loc_eesti_vabariik": "Eesti Vabariik",
  "loc_venemaa": "Venemaa",
  "loc_euroopa": "Euroopa",
  "loc_pärnu": "Pärnu",
  "loc_tartu": "Tartu",
  "loc_saaremaa": "Saaremaa",
  "loc_saksamaa": "Saksamaa",
  "loc_lasnamäe": "Lasnamäe",
  "loc_poola": "Poola",
  "loc_viljandi": "Viljandi",
  "loc_norra": "Norra",
  "loc_eesti_riik": "Eesti Riik",
  "loc_eestimaa": "Eestimaa",
  "loc_taani": "Taani",
  "loc_haapsalu": "Haapsalu",
  "loc_rootsi": "Rootsi",
  "loc_inglismaa": "Inglismaa",
  "loc_läti": "Läti",
  "loc_pariis": "Pariis",
  "loc_pirita": "Pirita",
  "loc_belgia": "Belgia",
  "loc_hiina": "Hiina",
  "loc_london": "London",
  "loc_hispaania": "Hispaania",
  "loc_rapla": "Rapla",
  "loc_türi": "Türi",
  "loc_viru": "Viru",
  "loc_holland": "Holland",
  "loc_itaalia": "Itaalia",
  "loc_jõgeval": "Jõgeval",
  "loc_leedu": "Leedu",
  "loc_gruusia": "Gruusia",
  "loc_india": "India",
  "loc_narva": "Narva",
  "loc_baltikum": "Baltikum",
  "loc_berliin": "Berliin",
  "loc_leningrad": "Leningrad",
  "loc_siber": "Siber",
  "loc_põlva": "Põlva",
  "loc_võrumaa": "Võrumaa",
  "loc_brüssel": "Brüssel",
  "loc_iisrael": "Iisrael",
  "loc_raplamaa": "Raplamaa",
  "loc_toompea": "Toompea",
  "loc_ülemiste": "Ülemiste",
  "loc_austraalia": "Austraalia",
  "loc_horvaatia": "Horvaatia",
  "loc_nõmme": "Nõmme",
  "loc_põhjamaa": "Põhjamaa",
  "loc_pöögelmann": "Pöögelmann",
  "loc_riia": "Riia",
  "loc_jaapan": "Jaapan",
  "loc_jõhvi": "Jõhvi",
  "loc_keila": "Keila",
  "loc_kihnu": "Kihnu",
  "loc_kreeka": "Kreeka",
  "loc_new_york": "New York",
  "loc_paldiski": "Paldiski",
  "loc_prantsusmaa": "Prantsusmaa",
  "loc_rakvere": "Rakvere",
  "loc_washington": "Washington",
  "loc_šveits": "Šveits",
  "loc_altmets": "Altmets",
  "loc_ameerika_ühendriik": "Ameerika Ühendriik",
  "loc_ateena": "Ateena",
  "loc_balti_riik": "Balti Riik",
  "loc_brasiilia": "Brasiilia",
  "loc_cotton": "Cotton",
  "loc_ecuador": "Ecuador",
  "loc_emajõe": "Emajõe",
  "loc_genf": "Genf",
  "loc_iirimaa": "Iirimaa",
  "loc_india_jiang": "India Jiang",
  "loc_istanbul": "Istanbul",
  "loc_jeruusalemma": "Jeruusalemma",
  "loc_jürk": "Jürk",
  "loc_kalamaja": "Kalamaja",
  "loc_keila_linn": "Keila Linn",
  "loc_kihnu_saar": "Kihnu Saar",
  "loc_koeru": "Koeru",
  "loc_kõrvemaa": "Kõrvemaa",
  "loc_kristiine": "Kristiine",
  "loc_kuusalu": "Kuusalu",
  "loc_leebe_küla": "Leebe Küla",
  "loc_lihula": "Lihula",
  "loc_liivimaa": "Liivimaa",
  "loc_marss": "Marss",
  "loc_mere_puiestee": "Mere Puiestee",
  "loc_monteeriana": "Monteeriana",
  "loc_muhu_saar": "Muhu Saar",
  "loc_märjamaa": "Märjamaa",
  "loc_niguline": "Niguline",
  "loc_nõukogude_hollywood": "Nõukogude Hollywood",
  "loc_padi": "Padi",
  "loc_saare-lääne": "Saare-lääne",
  "loc_saksa": "Saksa",
  "loc_singapur": "Singapur",
  "loc_stort": "Stort",
  "loc_taanimaa": "Taanimaa",
  "loc_tallinna_kesklinn": "Tallinna Kesklinn",
  "loc_tondi": "Tondi",
  "loc_torni_küla": "Torni Küla",
  "loc_usa": "Usa",
  "loc_vastseliina": "Vastseliina",
  "loc_viimsi": "Viimsi",
  "loc_windon": "Windon",
  "loc_aafrika": "Aafrika",
  "loc_altoni": "Altoni",
  "loc_amsterdam": "Amsterdam",
  "loc_audrus": "Audrus",
  "loc_barcelon": "Barcelon",
  "loc_dilberdas": "Dilberdas",
  "loc_emajõgi": "Emajõgi",
  "loc_euroopa_maa": "Euroopa Maa",
  "loc_gorbatšov": "Gorbatšov",
  "loc_harju": "Harju",
  "loc_kaarli": "Kaarli",
  "loc_kanada": "Kanada",
  "loc_kesk-eesti": "Kesk-eesti",
  "loc_kiiev": "Kiiev",
  "loc_kopli": "Kopli",
  "loc_kose": "Kose",
  "loc_kurdma": "Kurdma",
  "loc_ladina-ameerika": "Ladina-ameerika",
  "loc_lihula_vald": "Lihula Vald",
  "loc_lissabon": "Lissabon",
  "loc_läänemaa": "Läänemaa",
  "loc_matsalu": "Matsalu",
  "loc_metsküla": "Metsküla",
  "loc_monteerima": "Monteerima",
  "loc_mustamäe": "Mustamäe",
  "loc_nagunii": "Nagunii",
  "loc_nizza": "Nizza",
  "loc_paide": "Paide",
  "loc_parmas": "Parmas",
  "loc_põhja-eesti": "Põhja-eesti",
  "loc_pöidla": "Pöidla",
  "loc_rubla": "Rubla",
  "loc_supoljansk": "Supoljansk",
  "loc_tabasalu": "Tabasalu",
  "loc_tallinna_linn": "Tallinna Linn",
  "loc_tartumaa": "Tartumaa",
  "loc_torontos": "Torontos",
  "loc_tüüri": "Tüüri",
  "loc_vaivara": "Vaivara",
  "loc_veneetsia": "Veneetsia",
  "loc_volga": "Volga",
  "loc_värska": "Värska",
  "loc_aasia": "Aasia",
  "loc_amazon": "Amazon",
  "loc_antsu": "Antsu",
  "loc_bukarest": "Bukarest",
  "loc_donskatus": "Donskatus",
  "loc_elva": "Elva",
  "loc_essaugum": "Essaugum",
  "loc_freemia": "Freemia",
  "loc_iraak": "Iraak",
  "loc_itaalia_saar": "Itaalia Saar",
  "loc_jõhv": "Jõhv",
  "loc_kaarma": "Kaarma",
  "loc_karksi-nuia": "Karksi-nuia",
  "loc_ketšup": "Ketšup",
  "loc_kingissepa": "Kingissepa",
  "loc_koplis": "Koplis",
  "loc_kosovo": "Kosovo",
  "loc_kuressaare": "Kuressaare",
  "loc_lembiaamia": "Lembiaamia",
  "loc_liibanon": "Liibanon",
  "loc_mahtra": "Mahtra",
  "loc_matsalu_rahvuspark": "Matsalu Rahvuspark",
  "loc_mexico_citys": "Mexico Citys",
  "loc_monteeris": "Monteeris",
  "loc_mustamäe_emo": "Mustamäe Emo",
  "loc_nõukogude_maailm": "Nõukogude Maailm",
  "loc_paie": "Paie",
  "loc_pikamaa": "Pikamaa",
  "loc_portugal": "Portugal",
  "loc_rumeenia": "Rumeenia",
  "loc_saina": "Saina",
  "loc_seejärel": "Seejärel",
  "loc_sosmondlaslannantaažija": "Sosmondlaslannantaažija",
  "loc_suurbritannia": "Suurbritannia",
  "loc_tais": "Tais",
  "loc_tallinn_helsingi": "Tallinn Helsingi",
  "loc_tartu_linn": "Tartu Linn",
  "loc_toris": "Toris",
  "loc_tõrva": "Tõrva",
  "loc_tšetšeenia": "Tšetšeenia",
  "loc_valga": "Valga",
  "loc_vilsandi_saar": "Vilsandi Saar",
  "loc_vormsi": "Vormsi",
  "loc_vääna": "Vääna",
  "loc_ärgoit": "Ärgoit",
  "loc_afganistan": "Afganistan",
  "loc_armeenia": "Armeenia",
  "loc_california": "California",
  "loc_džaul": "Džaul",
  "loc_eesti_nsv": "Eesti Nsv",
  "loc_elysee": "Elysee",
  "loc_estonian": "Estonian",
  "loc_gazprom": "Gazprom",
  "loc_haapsald": "Haapsald",
  "loc_hiiumaa": "Hiiumaa",
  "loc_ida-euroopa": "Ida-euroopa",
  "loc_indiaan": "Indiaan",
  "loc_iraan": "Iraan",
  "loc_kaks": "Kaks",
  "loc_kiviõli": "Kiviõli",
  "loc_kõrval": "Kõrval",
  "loc_kuusald": "Kuusald",
  "loc_lavka": "Lavka",
  "loc_liibüa": "Liibüa",
  "loc_lubama": "Lubama",
  "loc_maroko": "Maroko",
  "loc_mehhiko": "Mehhiko",
  "loc_minsk": "Minsk",
  "loc_must_meri": "Must Meri",
  "loc_odessa": "Odessa",
  "loc_pika_hermanni": "Pika Hermanni",
  "loc_põltsamaa": "Põltsamaa",
  "loc_rooma": "Rooma",
  "loc_räpina": "Räpina",
  "loc_sakala": "Sakala",
  "loc_stockholm": "Stockholm",
  "loc_tapa": "Tapa",
  "loc_tema": "Tema",
  "loc_torn": "Torn",
  "loc_tosso": "Tosso",
  "loc_ukraina": "Ukraina",
  "loc_valgusmaa": "Valgusmaa",
  "loc_vigala": "Vigala",
  "loc_virtsu": "Virtsu",
  "loc_võrtsjärv": "Võrtsjärv",
  "org_tallinnfilm": "Tallinnfilm",
  "org_tallinn": "Tallinn",
  "org_tallinn_film": "Tallinn Film",
  "org_eesti": "Eesti",
  "org_tartu_ülikool": "Tartu Ülikool",
  "org_tallinna_ülikool": "Tallinna Ülikool",
  "org_eesti_televisioon": "Eesti Televisioon",
  "org_err": "Err",
  "org_eesti_film": "Eesti Film",
  "org_estonia": "Estonia",
  "org_eesti_filmi_instituut": "Eesti Filmi Instituut",
  "org_raadio_kaks": "Raadio Kaks",
  "org_rimi": "Rimi",
  "org_twitter": "Twitter",
  "org_eesti_valitsus": "Eesti Valitsus",
  "org_etv": "Etv",
  "org_instagram": "Instagram",
  "org_eesti_raadio": "Eesti Raadio",
  "org_westholmi_gümnaasium": "Westholmi Gümnaasium",
  "org_bfm": "Bfm",
  "org_peda": "Peda",
  "org_baumani_tehas": "Baumani Tehas",
  "org_coca-cola": "Coca-cola",
  "org_diplomaatia": "Diplomaatia",
  "org_elisa": "Elisa",
  "org_ep": "Ep",
  "org_estonian_saar": "Estonian Saar",
  "org_gpu": "Gpu",
  "org_ilumäe_kolhoos": "Ilumäe Kolhoos",
  "org_kihnu_kool": "Kihnu Kool",
  "org_kreml": "Kreml",
  "org_lihula_vallavalitsus": "Lihula Vallavalitsus",
  "org_maaleht": "Maaleht",
  "org_moskva_televisioon": "Moskva Televisioon",
  "org_nato": "Nato",
  "org_pirita_klooster": "Pirita Klooster",
  "org_päevaleht": "Päevaleht",
  "org_tallinna_kinostuudio": "Tallinna Kinostuudio",
  "org_tallinna_sidekool": "Tallinna Sidekool",
  "org_teaduste_akadeemia": "Teaduste Akadeemia",
  "org_vene_sõjavägi": "Vene Sõjavägi",
  "org_volkswagen": "Volkswagen",
  "org_bbc_surnalistika": "Bbc Surnalistika",
  "org_coop_pank": "Coop Pank",
  "org_eeeffi": "Eeeffi",
  "org_eesti_kinokomitee": "Eesti Kinokomitee",
  "org_elo_rand": "Elo Rand",
  "org_haapsalu_kirik": "Haapsalu Kirik",
  "org_kik": "Kik",
  "org_kunstiteos": "Kunstiteos",
  "org_liivimaa_ord": "Liivimaa Ord",
  "org_metsküla_kool": "Metsküla Kool",
  "org_ms": "Ms",
  "org_nordea": "Nordea",
  "org_pirita_open": "Pirita Open",
  "org_pärnu_lade": "Pärnu Lade",
  "org_raasiku_haigla": "Raasiku Haigla",
  "org_soome_kompartei": "Soome Kompartei",
  "org_tallinna_kaarli_kirik": "Tallinna Kaarli Kirik",
  "org_tallinna_linnavalitsus": "Tallinna Linnavalitsus",
  "org_tallinna_tallinn_akadeemia": "Tallinna Tallinn Akadeemia",
  "org_top": "Top",
  "org_türi_keskkool": "Türi Keskkool",
  "org_vigala_maarja": "Vigala Maarja",
  "org_väimela_tehnikum": "Väimela Tehnikum",
  "org_belgia_ühiskond": "Belgia Ühiskond",
  "org_cv-online": "Cv-online",
  "org_eka": "Eka",
  "org_emex": "Emex",
  "org_erso": "Erso",
  "org_euroopa_kino": "Euroopa Kino",
  "org_hiv": "Hiv",
  "org_kaitseliit": "Kaitseliit",
  "org_kirjanike_liit": "Kirjanike Liit",
  "org_laagri_kool": "Laagri Kool",
  "org_line": "Line",
  "org_montaaž": "Montaaž",
  "org_mustpeade_maja": "Mustpeade Maja",
  "org_õhtuleht": "Õhtuleht",
  "org_politseiprefektuur": "Politseiprefektuur",
  "org_pärnu_muuseum": "Pärnu Muuseum",
  "org_rahvusooper_estonia": "Rahvusooper Estonia",
  "org_stockholmi_tehnikainstituut": "Stockholmi Tehnikainstituut",
  "org_tallinna_kesklinna_valitsus": "Tallinna Kesklinna Valitsus",
  "org_tallinna_reaalkool": "Tallinna Reaalkool",
  "org_tallinna_tehnikaülikool": "Tallinna Tehnikaülikool",
  "org_tartu": "Tartu",
  "org_tular": "Tular",
  "org_valgus": "Valgus",
  "org_vigala_maarja_kogudus": "Vigala Maarja Kogudus",
  "org_danske_pank": "Danske Pank",
  "org_eesti_telefilm": "Eesti Telefilm",
  "org_ekn": "Ekn",
  "org_emp": "Emp",
  "org_euroopa_liit": "Euroopa Liit",
  "org_hong_travel": "Hong Travel",
  "org_kaks": "Kaks",
  "org_kolga_kool": "Kolga Kool",
  "org_lihula_kool": "Lihula Kool",
  "org_lutsukomm": "Lutsukomm",
  "org_moskva_kinokool": "Moskva Kinokool",
  "org_napol": "Napol",
  "org_pro": "Pro",
  "org_pöff": "Pöff",
  "org_rakvere_tarbijate": "Rakvere Tarbijate",
  "org_tallink": "Tallink",
  "org_tallinna_kino": "Tallinna Kino",
  "org_tallinna_riiklik": "Tallinna Riiklik",
  "org_tulevik": "Tulevik",
  "org_vangla": "Vangla",
  "org_viljandi_kultuuriakadeemia": "Viljandi Kultuuriakadeemia",
  "org_ülemiste_keskus": "Ülemiste Keskus",
  "per_maria": "Maria",
  "per_karl": "Karl",
  "per_paul": "Paul",
  "per_jeesus": "Jeesus",
  "per_johannes": "Johannes",
  "per_andrei": "Andrei",
  "per_harry": "Harry",
  "per_maarja": "Maarja",
  "per_mark_soosaar": "Mark Soosaar",
  "per_alex": "Alex",
  "per_laura": "Laura",
  "per_leida_laius": "Leida Laius",
  "per_mark": "Mark",
  "per_peeter_tooming": "Peeter Tooming",
  "per_ise": "Ise",
  "per_kaspar": "Kaspar",
  "per_mart_otsa": "Mart Otsa",
  "per_sõber": "Sõber",
  "per_andres_sööt": "Andres Sööt",
  "per_jakob": "Jakob",
  "per_sofi": "Sofi",
  "per_valeria_anderson": "Valeria Anderson",
  "per_anton": "Anton",
  "per_arvo_iho": "Arvo Iho",
  "per_mait_mäekivi": "Mait Mäekivi",
  "per_mati_kask": "Mati Kask",
  "per_taivo_denso": "Taivo Denso",
  "per_aleksander": "Aleksander",
  "per_barbara": "Barbara",
  "per_kaljo_kiisk": "Kaljo Kiisk",
  "per_kelly": "Kelly",
  "per_marie": "Marie",
  "per_mati_unt": "Mati Unt",
  "per_olema": "Olema",
  "per_peetrus": "Peetrus",
  "per_andrese": "Andrese",
  "per_härra_baumann": "Härra Baumann",
  "per_jaak_aus": "Jaak Aus",
  "per_jaan_tätte": "Jaan Tätte",
  "per_jeesu": "Jeesu",
  "per_joachter": "Joachter",
  "per_joonas_loit": "Joonas Loit",
  "per_jumala_raids": "Jumala Raids",
  "per_jüri_mängufilm": "Jüri Mängufilm",
  "per_jäär": "Jäär",
  "per_kadina": "Kadina",
  "per_kaido": "Kaido",
  "per_kalmer_tennosaar": "Kalmer Tennosaar",
  "per_kerdama": "Kerdama",
  "per_kimi_räikkönen": "Kimi Räikkönen",
  "per_kolli_sten": "Kolli Sten",
  "per_kristel_aaslaid": "Kristel Aaslaid",
  "per_kukkonde": "Kukkonde",
  "per_langipar": "Langipar",
  "per_lesk": "Lesk",
  "per_linda_rummo": "Linda Rummo",
  "per_luitsa": "Luitsa",
  "per_madis_veldman": "Madis Veldman",
  "per_manto": "Manto",
  "per_mari-liis": "Mari-liis",
  "per_maria_ardo": "Maria Ardo",
  "per_marika_reintam": "Marika Reintam",
  "per_martin_helme": "Martin Helme",
  "per_mattias_naan": "Mattias Naan",
  "per_metsvinthall": "Metsvinthall",
  "per_mikko_mägi": "Mikko Mägi",
  "per_mirtel_pohla": "Mirtel Pohla",
  "per_murrs": "Murrs",
  "per_nikita_sergejevitš": "Nikita Sergejevitš",
  "per_nõmmi": "Nõmmi",
  "per_orparvate": "Orparvate",
  "per_paul-eerik_rummo": "Paul-eerik Rummo",
  "per_peedu_ojamaa": "Peedu Ojamaa",
  "per_piia_frous": "Piia Frous",
  "per_porno": "Porno",
  "per_pušk": "Pušk",
  "per_raimond_kolga": "Raimond Kolga",
  "per_rando_pettai": "Rando Pettai",
  "per_reili_saar": "Reili Saar",
  "per_rein_maran": "Rein Maran",
  "per_rene_morr": "Rene Morr",
  "per_riinot": "Riinot",
  "per_roger": "Roger",
  "per_rummu_jüri": "Rummu Jüri",
  "per_saara": "Saara",
  "per_shell": "Shell",
  "per_sulev_mäeltsemees": "Sulev Mäeltsemees",
  "per_tanel": "Tanel",
  "per_tema": "Tema",
  "per_tiiu": "Tiiu",
  "per_tõnis_kask": "Tõnis Kask",
  "per_torove": "Torove",
  "per_tuuli_rand": "Tuuli Rand",
  "per_urmas_tamm": "Urmas Tamm",
  "per_vaisse": "Vaisse",
  "per_valentin_kuik": "Valentin Kuik",
  "per_viive_leol": "Viive Leol",
  "per_vladimir_luts": "Vladimir Luts",
  "per_walter": "Walter",
  "per_šamaan": "Šamaan",
  "per_aabel": "Aabel",
  "per_ago_ruus": "Ago Ruus",
  "per_albert_hermann": "Albert Hermann",
  "per_andrus_stop": "Andrus Stop",
  "per_anspartal": "Anspartal",
  "per_ants_jõgi": "Ants Jõgi",
  "per_artra": "Artra",
  "per_august_tsirk": "August Tsirk",
  "per_berg": "Berg",
  "per_birmakera": "Birmakera",
  "per_carl_juunior": "Carl Juunior",
  "per_czukai": "Czukai",
  "per_dior": "Dior",
  "per_edgar_savisaar": "Edgar Savisaar",
  "per_edward_munk": "Edward Munk",
  "per_eerik_roosta": "Eerik Roosta",
  "per_eino_parss": "Eino Parss",
  "per_emil_rutiku": "Emil Rutiku",
  "per_enn_olev": "Enn Olev",
  "per_evald_hermaküla": "Evald Hermaküla",
  "per_gabriella_farrita": "Gabriella Farrita",
  "per_halleib": "Halleib",
  "per_harakas": "Harakas",
  "per_hasart": "Hasart",
  "per_helen_raivo": "Helen Raivo",
  "per_herbert_tul": "Herbert Tul",
  "per_ilter": "Ilter",
  "per_ivandratšov": "Ivandratšov",
  "per_jaan_kolbr": "Jaan Kolbr",
  "per_joosep_kristjan": "Joosep Kristjan",
  "per_jürgen_ligi": "Jürgen Ligi",
  "per_jüri_saar": "Jüri Saar",
  "per_kaamer": "Kaamer",
  "per_kadi_mats": "Kadi Mats",
  "per_kaisa_laos": "Kaisa Laos",
  "per_kapler": "Kapler",
  "per_katorajad": "Katorajad",
  "per_kihvt": "Kihvt",
  "per_kingsepa": "Kingsepa",
  "per_konstantin_päts": "Konstantin Päts",
  "per_kristiina": "Kristiina",
  "per_kuskil": "Kuskil",
  "per_lietuvos": "Lietuvos",
  "per_loll": "Loll",
  "per_luther_mattiisen": "Luther Mattiisen",
  "per_maimi_kilm": "Maimi Kilm",
  "per_maretskaja": "Maretskaja",
  "per_mari-liis_jakobson": "Mari-liis Jakobson",
  "per_maria_laidoner": "Maria Laidoner",
  "per_mari_tamm": "Mari Tamm",
  "per_mart_helme": "Mart Helme",
  "per_mart_siimann": "Mart Siimann",
  "per_mcip": "Mcip",
  "per_mia": "Mia",
  "per_mikkus": "Mikkus",
  "per_mirty": "Mirty",
  "per_mäkidet": "Mäkidet",
  "per_nikolai": "Nikolai",
  "per_nornio": "Nornio",
  "per_otto": "Otto",
  "per_paul_mattiisen": "Paul Mattiisen",
  "per_peeter_simm": "Peeter Simm",
  "per_piia_roosi": "Piia Roosi",
  "per_pornovideode": "Pornovideode",
  "per_pärnika": "Pärnika",
  "per_raimond_tamm": "Raimond Tamm",
  "per_regina": "Regina",
  "per_reinhold_rotermanni": "Reinhold Rotermanni",
  "per_rein_raamat": "Rein Raamat",
  "per_rene_puura": "Rene Puura",
  "per_risto_puri": "Risto Puri",
  "per_roland_saagravu": "Roland Saagravu",
  "per_räägi-rääk": "Räägi-rääk",
  "per_sander_mölder": "Sander Mölder",
  "per_siiri_oviir": "Siiri Oviir",
  "per_sünge": "Sünge",
  "per_tapport": "Tapport",
  "per_tenkeš": "Tenkeš",
  "per_timbuling": "Timbuling",
  "per_tõnu_naissoo": "Tõnu Naissoo",
  "per_tuul": "Tuul",
  "per_tšekki": "Tšekki",
  "per_urvaka": "Urvaka",
  "per_valdemar": "Valdemar",
  "per_viivi_luik": "Viivi Luik",
  "per_vladimir_parvel": "Vladimir Parvel",
  "per_william": "William",
  "per_aare_tilk": "Aare Tilk",
  "per_aino_ene": "Aino Ene",
  "per_albert_tuganov": "Albert Tuganov",
  "per_andruse": "Andruse",
  "per_animal": "Animal",
  "per_ants_kaljurand": "Ants Kaljurand",
  "per_bach": "Bach",
  "per_bernard_kangro": "Bernard Kangro",
  "per_brunoga": "Brunoga",
  "per_chardonnay": "Chardonnay",
  "per_daša_otto": "Daša Otto",
  "per_dmitri": "Dmitri",
  "per_eduard_grenzstein": "Eduard Grenzstein",
  "per_eeriku": "Eeriku",
  "per_eeva_brown": "Eeva Brown",
  "per_elephants": "Elephants",
  "per_endel_pärn": "Endel Pärn",
  "per_erikurat": "Erikurat",
  "per_eve_kivi": "Eve Kivi",
  "per_grete_kaljuste": "Grete Kaljuste",
  "per_hannes_kaljujärv": "Hannes Kaljujärv",
  "per_heiki_ernits": "Heiki Ernits",
  "per_helen_vinogradov": "Helen Vinogradov",
  "per_herbert_tulp": "Herbert Tulp",
  "per_ingrid_ing": "Ingrid Ing",
  "per_ivan_puunima": "Ivan Puunima",
  "per_jaan_tasa": "Jaan Tasa",
  "per_janno_pipathanka": "Janno Pipathanka",
  "per_jekaterina_winaagratskaja": "Jekaterina Winaagratskaja",
  "per_johannes_vares-barbarus": "Johannes Vares-barbarus",
  "per_joosep_tamm": "Joosep Tamm",
  "per_jüril": "Jüril",
  "per_jüri_sillart": "Jüri Sillart",
  "per_kaamera": "Kaamera",
  "per_kadri_kanter": "Kadri Kanter",
  "per_kalfi": "Kalfi",
  "per_kaur_mägi": "Kaur Mägi",
  "per_kilekott": "Kilekott",
  "per_kino": "Kino",
  "per_kõrboja": "Kõrboja",
  "per_kristjan_mari": "Kristjan Mari",
  "per_kuskilt": "Kuskilt",
  "per_lietuvos_sostame": "Lietuvos Sostame",
  "per_loolaiper": "Loolaiper",
  "per_maalit": "Maalit",
  "per_maretzca": "Maretzca",
  "per_maria_norman": "Maria Norman",
  "per_mart_kessel": "Mart Kessel",
  "per_meelis_loovere": "Meelis Loovere",
  "per_michael_martin": "Michael Martin",
  "per_mikk_rand": "Mikk Rand",
  "per_mitta_aleksander": "Mitta Aleksander",
  "per_naatsaret": "Naatsaret",
  "per_nipernaad": "Nipernaad",
  "per_okova": "Okova",
  "per_pajusti": "Pajusti",
  "per_pavel_kubo": "Pavel Kubo",
  "per_pirete": "Pirete",
  "per_priit_pärn": "Priit Pärn",
  "per_rabak": "Rabak",
  "per_rain_simmul": "Rain Simmul",
  "per_regina_meri": "Regina Meri",
  "per_rein_kootu": "Rein Kootu",
  "per_remurd": "Remurd",
  "per_revo": "Revo",
  "per_robert_kas": "Robert Kas",
  "per_ron": "Ron",
  "per_rääkima": "Rääkima",
  "per_sandra": "Sandra",
  "per_siljardül": "Siljardül",
  "per_stefan": "Stefan",
  "per_taylor": "Taylor",
  "per_terje_talv": "Terje Talv",
  "per_toivo_helme": "Toivo Helme",
  "per_tõnu_virve": "Tõnu Virve",
  "per_tuuline": "Tuuline",
  "per_uku_masing": "Uku Masing",
  "per_urve_palo": "Urve Palo",
  "per_valdemar_ist": "Valdemar Ist",
  "per_vasak": "Vasak",
  "per_virv": "Virv",
  "per_voldemar_jänes": "Voldemar Jänes",
  "per_ülo_tambek": "Ülo Tambek",
  "per_adolf_hitler": "Adolf Hitler",
  "per_aitäh": "Aitäh",
  "per_andrei_tarkovski": "Andrei Tarkovski",
  "per_andrus_ansip": "Andrus Ansip",
  "per_anna-brita": "Anna-brita",
  "per_anton_hansen": "Anton Hansen",
  "per_ants_park": "Ants Park",
  "per_arvo_kukumägi": "Arvo Kukumägi",
  "per_betti_alver": "Betti Alver",
  "per_bruno_limbak": "Bruno Limbak",
  "per_children": "Children",
  "per_dennis_potter": "Dennis Potter",
  "per_dmitri_mattiis": "Dmitri Mattiis",
  "per_edward": "Edward",
  "per_eerik_kruus": "Eerik Kruus",
  "per_eevi_silla": "Eevi Silla",
  "per_elite": "Elite",
  "per_endel_rita": "Endel Rita",
  "per_ester_väljaots": "Ester Väljaots",
  "per_fengher": "Fengher",
  "per_grimmide": "Grimmide",
  "per_hannes_võrno": "Hannes Võrno",
  "per_harry_martinson": "Harry Martinson",
  "per_heino_pars": "Heino Pars",
  "per_helmi": "Helmi",
  "per_hildsoff": "Hildsoff",
  "per_ira": "Ira",
  "per_ivo_linna": "Ivo Linna",
  "per_jaan_toominga": "Jaan Toominga",
  "per_jan_uus": "Jan Uus",
  "per_jevgeni_hirmoonia": "Jevgeni Hirmoonia",
  "per_john_jean": "John Jean",
  "per_juhan": "Juhan",
  "per_jüri_müür": "Jüri Müür",
  "per_jüri_sillarta": "Jüri Sillarta",
  "per_kaarel_kurismaa": "Kaarel Kurismaa",
  "per_kadri_karu": "Kadri Karu",
  "per_karl_markus": "Karl Markus",
  "per_kim": "Kim",
  "per_kirill": "Kirill",
  "per_kristel_aa": "Kristel Aa",
  "per_kristus": "Kristus",
  "per_laano": "Laano",
  "per_leis": "Leis",
  "per_limbul": "Limbul",
  "per_louis_kristo": "Louis Kristo",
  "per_mait_rufe": "Mait Rufe",
  "per_margus_tamme": "Margus Tamme",
  "per_maria_aleksei": "Maria Aleksei",
  "per_mart_laar": "Mart Laar",
  "per_merle_karusoo": "Merle Karusoo",
  "per_mihkel_anna-brita": "Mihkel Anna-brita",
  "per_mikk_sarv": "Mikk Sarv",
  "per_monika": "Monika",
  "per_nikita_michalkov": "Nikita Michalkov",
  "per_nipernaat": "Nipernaat",
  "per_peeaa": "Peeaa",
  "per_piret_kaljuste": "Piret Kaljuste",
  "per_puriood": "Puriood",
  "per_rail": "Rail",
  "per_raivo_maria": "Raivo Maria",
  "per_reija": "Reija",
  "per_rein_mara": "Rein Mara",
  "per_rene_haljas": "Rene Haljas",
  "per_riinat": "Riinat",
  "per_robert_kask": "Robert Kask",
  "per_ronaldo": "Ronaldo",
  "per_saagnemy": "Saagnemy",
  "per_sauvignon_blanc": "Sauvignon Blanc",
  "per_smilers": "Smilers",
  "per_sulev_keedus": "Sulev Keedus",
  "per_tamand_višnu": "Tamand Višnu",
  "per_teet_kallas": "Teet Kallas",
  "per_tiima": "Tiima",
  "per_tom_tamme": "Tom Tamme",
  "per_toomas_crumpa": "Toomas Crumpa",
  "per_tuuli_kool": "Tuuli Kool",
  "per_uno_naissoo": "Uno Naissoo",
  "per_vadja_jürkare": "Vadja Jürkare",
  "per_valentin": "Valentin",
  "per_vettumart": "Vettumart",
  "per_virve_reiman": "Virve Reiman",
  "per_vufa": "Vufa",
  "per_äkki": "Äkki",
  "per_adolf_test": "Adolf Test",
  "per_albert": "Albert",
  "per_aleksei_tony": "Aleksei Tony",
  "per_andrus_paavel": "Andrus Paavel",
  "per_anne_mere": "Anne Mere",
  "per_anton_hansen_tammsaare": "Anton Hansen Tammsaare",
  "per_arnold_luther": "Arnold Luther",
  "per_arvo_pärt": "Arvo Pärt",
  "per_beff": "Beff",
  "per_bhabai": "Bhabai",
  "per_bruno_noppanen": "Bruno Noppanen",
  "per_christopher_louis": "Christopher Louis",
  "per_dimitri_mattiisen": "Dimitri Mattiisen",
  "per_dmitri_mattiisen": "Dmitri Mattiisen",
  "per_edwardi": "Edwardi",
  "per_eerik_las": "Eerik Las",
  "per_eha_masing": "Eha Masing",
  "per_elo_rand": "Elo Rand",
  "per_endel_sven": "Endel Sven",
  "per_evald_aavik": "Evald Aavik",
  "per_ferik": "Ferik",
  "per_gustav": "Gustav",
  "per_hans": "Hans",
  "per_harry_rehe": "Harry Rehe",
  "per_helenal": "Helenal",
  "per_hendrik_sal-saller": "Hendrik Sal-saller",
  "per_hille_tarto": "Hille Tarto"
}

export const firstData = [
  [
    "loc_eesti",
    95,
    null
  ],
  [
    "loc_tallinn",
    41,
    null
  ],
  [
    "loc_soome",
    19,
    null
  ],
  [
    "loc_moskva",
    19,
    null
  ],
  [
    "loc_ameerika",
    15,
    null
  ],
  [
    "loc_nõukogude_liit",
    12,
    null
  ],
  [
    "loc_eesti_vabariik",
    11,
    null
  ],
  [
    "loc_venemaa",
    11,
    null
  ],
  [
    "loc_euroopa",
    10,
    null
  ],
  [
    "loc_pärnu",
    10,
    null
  ],
  [
    "loc_tartu",
    10,
    null
  ],
  [
    "loc_saaremaa",
    10,
    null
  ],
  [
    "loc_saksamaa",
    9,
    null
  ],
  [
    "loc_lasnamäe",
    8,
    null
  ],
  [
    "loc_poola",
    7,
    null
  ],
  [
    "loc_viljandi",
    7,
    null
  ],
  [
    "loc_norra",
    7,
    null
  ],
  [
    "loc_eesti_riik",
    6,
    null
  ],
  [
    "loc_eestimaa",
    6,
    null
  ],
  [
    "loc_taani",
    6,
    null
  ],
  [
    "loc_haapsalu",
    5,
    null
  ],
  [
    "loc_rootsi",
    5,
    null
  ],
  [
    "loc_inglismaa",
    5,
    null
  ],
  [
    "loc_läti",
    4,
    null
  ],
  [
    "loc_pariis",
    4,
    null
  ],
  [
    "loc_pirita",
    4,
    null
  ],
  [
    "loc_belgia",
    4,
    null
  ],
  [
    "loc_hiina",
    4,
    null
  ],
  [
    "loc_london",
    4,
    null
  ],
  [
    "loc_hispaania",
    3,
    null
  ],
  [
    "loc_rapla",
    3,
    null
  ],
  [
    "loc_türi",
    3,
    null
  ],
  [
    "loc_viru",
    3,
    null
  ],
  [
    "loc_holland",
    3,
    null
  ],
  [
    "loc_itaalia",
    3,
    null
  ],
  [
    "loc_jõgeval",
    3,
    null
  ],
  [
    "loc_leedu",
    3,
    null
  ],
  [
    "loc_gruusia",
    3,
    null
  ],
  [
    "loc_india",
    3,
    null
  ],
  [
    "loc_narva",
    3,
    null
  ],
  [
    "loc_baltikum",
    3,
    null
  ],
  [
    "loc_berliin",
    3,
    null
  ],
  [
    "loc_leningrad",
    3,
    null
  ],
  [
    "loc_siber",
    3,
    null
  ],
  [
    "loc_põlva",
    2,
    null
  ],
  [
    "loc_võrumaa",
    2,
    null
  ],
  [
    "loc_brüssel",
    2,
    null
  ],
  [
    "loc_iisrael",
    2,
    null
  ],
  [
    "loc_raplamaa",
    2,
    null
  ],
  [
    "loc_toompea",
    2,
    null
  ],
  [
    "loc_ülemiste",
    2,
    null
  ],
  [
    "loc_austraalia",
    2,
    null
  ],
  [
    "loc_horvaatia",
    2,
    null
  ],
  [
    "loc_nõmme",
    2,
    null
  ],
  [
    "loc_põhjamaa",
    2,
    null
  ],
  [
    "loc_pöögelmann",
    2,
    null
  ],
  [
    "loc_riia",
    2,
    null
  ],
  [
    "loc_jaapan",
    2,
    null
  ],
  [
    "loc_jõhvi",
    2,
    null
  ],
  [
    "loc_keila",
    2,
    null
  ],
  [
    "loc_kihnu",
    2,
    null
  ],
  [
    "loc_kreeka",
    2,
    null
  ],
  [
    "loc_new_york",
    2,
    null
  ],
  [
    "loc_paldiski",
    2,
    null
  ],
  [
    "loc_prantsusmaa",
    2,
    null
  ],
  [
    "loc_rakvere",
    2,
    null
  ],
  [
    "loc_washington",
    2,
    null
  ],
  [
    "loc_šveits",
    2,
    null
  ],
  [
    "loc_altmets",
    1,
    null
  ],
  [
    "loc_ameerika_ühendriik",
    1,
    null
  ],
  [
    "loc_ateena",
    1,
    null
  ],
  [
    "loc_balti_riik",
    1,
    null
  ],
  [
    "loc_brasiilia",
    1,
    null
  ],
  [
    "loc_cotton",
    1,
    null
  ],
  [
    "loc_ecuador",
    1,
    null
  ],
  [
    "loc_emajõe",
    1,
    null
  ],
  [
    "loc_genf",
    1,
    null
  ],
  [
    "loc_iirimaa",
    1,
    null
  ],
  [
    "loc_india_jiang",
    1,
    null
  ],
  [
    "loc_istanbul",
    1,
    null
  ],
  [
    "loc_jeruusalemma",
    1,
    null
  ],
  [
    "loc_jürk",
    1,
    null
  ],
  [
    "loc_kalamaja",
    1,
    null
  ],
  [
    "loc_keila_linn",
    1,
    null
  ],
  [
    "loc_kihnu_saar",
    1,
    null
  ],
  [
    "loc_koeru",
    1,
    null
  ],
  [
    "loc_kõrvemaa",
    1,
    null
  ],
  [
    "loc_kristiine",
    1,
    null
  ],
  [
    "loc_kuusalu",
    1,
    null
  ],
  [
    "loc_leebe_küla",
    1,
    null
  ],
  [
    "loc_lihula",
    1,
    null
  ],
  [
    "loc_liivimaa",
    1,
    null
  ],
  [
    "loc_marss",
    1,
    null
  ],
  [
    "loc_mere_puiestee",
    1,
    null
  ],
  [
    "loc_monteeriana",
    1,
    null
  ],
  [
    "loc_muhu_saar",
    1,
    null
  ],
  [
    "loc_märjamaa",
    1,
    null
  ],
  [
    "loc_niguline",
    1,
    null
  ],
  [
    "loc_nõukogude_hollywood",
    1,
    null
  ],
  [
    "loc_padi",
    1,
    null
  ],
  [
    "loc_saare-lääne",
    1,
    null
  ],
  [
    "loc_saksa",
    1,
    null
  ],
  [
    "loc_singapur",
    1,
    null
  ],
  [
    "loc_stort",
    1,
    null
  ],
  [
    "loc_taanimaa",
    1,
    null
  ],
  [
    "loc_tallinna_kesklinn",
    1,
    null
  ],
  [
    "loc_tondi",
    1,
    null
  ],
  [
    "loc_torni_küla",
    1,
    null
  ],
  [
    "loc_usa",
    1,
    null
  ],
  [
    "loc_vastseliina",
    1,
    null
  ],
  [
    "loc_viimsi",
    1,
    null
  ],
  [
    "loc_windon",
    1,
    null
  ],
  [
    "loc_aafrika",
    1,
    null
  ],
  [
    "loc_altoni",
    1,
    null
  ],
  [
    "loc_amsterdam",
    1,
    null
  ],
  [
    "loc_audrus",
    1,
    null
  ],
  [
    "loc_barcelon",
    1,
    null
  ],
  [
    "loc_dilberdas",
    1,
    null
  ],
  [
    "loc_emajõgi",
    1,
    null
  ],
  [
    "loc_euroopa_maa",
    1,
    null
  ],
  [
    "loc_gorbatšov",
    1,
    null
  ],
  [
    "loc_harju",
    1,
    null
  ],
  [
    "loc_kaarli",
    1,
    null
  ],
  [
    "loc_kanada",
    1,
    null
  ],
  [
    "loc_kesk-eesti",
    1,
    null
  ],
  [
    "loc_kiiev",
    1,
    null
  ],
  [
    "loc_kopli",
    1,
    null
  ],
  [
    "loc_kose",
    1,
    null
  ],
  [
    "loc_kurdma",
    1,
    null
  ],
  [
    "loc_ladina-ameerika",
    1,
    null
  ],
  [
    "loc_lihula_vald",
    1,
    null
  ],
  [
    "loc_lissabon",
    1,
    null
  ],
  [
    "loc_läänemaa",
    1,
    null
  ],
  [
    "loc_matsalu",
    1,
    null
  ],
  [
    "loc_metsküla",
    1,
    null
  ],
  [
    "loc_monteerima",
    1,
    null
  ],
  [
    "loc_mustamäe",
    1,
    null
  ],
  [
    "loc_nagunii",
    1,
    null
  ],
  [
    "loc_nizza",
    1,
    null
  ],
  [
    "loc_paide",
    1,
    null
  ],
  [
    "loc_parmas",
    1,
    null
  ],
  [
    "loc_põhja-eesti",
    1,
    null
  ],
  [
    "loc_pöidla",
    1,
    null
  ],
  [
    "loc_rubla",
    1,
    null
  ],
  [
    "loc_supoljansk",
    1,
    null
  ],
  [
    "loc_tabasalu",
    1,
    null
  ],
  [
    "loc_tallinna_linn",
    1,
    null
  ],
  [
    "loc_tartumaa",
    1,
    null
  ],
  [
    "loc_torontos",
    1,
    null
  ],
  [
    "loc_tüüri",
    1,
    null
  ],
  [
    "loc_vaivara",
    1,
    null
  ],
  [
    "loc_veneetsia",
    1,
    null
  ],
  [
    "loc_volga",
    1,
    null
  ],
  [
    "loc_värska",
    1,
    null
  ],
  [
    "loc_aasia",
    1,
    null
  ],
  [
    "loc_amazon",
    1,
    null
  ],
  [
    "loc_antsu",
    1,
    null
  ],
  [
    "loc_bukarest",
    1,
    null
  ],
  [
    "loc_donskatus",
    1,
    null
  ],
  [
    "loc_elva",
    1,
    null
  ],
  [
    "loc_essaugum",
    1,
    null
  ],
  [
    "loc_freemia",
    1,
    null
  ],
  [
    "loc_iraak",
    1,
    null
  ],
  [
    "loc_itaalia_saar",
    1,
    null
  ],
  [
    "loc_jõhv",
    1,
    null
  ],
  [
    "loc_kaarma",
    1,
    null
  ],
  [
    "loc_karksi-nuia",
    1,
    null
  ],
  [
    "loc_ketšup",
    1,
    null
  ],
  [
    "loc_kingissepa",
    1,
    null
  ],
  [
    "loc_koplis",
    1,
    null
  ],
  [
    "loc_kosovo",
    1,
    null
  ],
  [
    "loc_kuressaare",
    1,
    null
  ],
  [
    "loc_lembiaamia",
    1,
    null
  ],
  [
    "loc_liibanon",
    1,
    null
  ],
  [
    "loc_mahtra",
    1,
    null
  ],
  [
    "loc_matsalu_rahvuspark",
    1,
    null
  ],
  [
    "loc_mexico_citys",
    1,
    null
  ],
  [
    "loc_monteeris",
    1,
    null
  ],
  [
    "loc_mustamäe_emo",
    1,
    null
  ],
  [
    "loc_nõukogude_maailm",
    1,
    null
  ],
  [
    "loc_paie",
    1,
    null
  ],
  [
    "loc_pikamaa",
    1,
    null
  ],
  [
    "loc_portugal",
    1,
    null
  ],
  [
    "loc_rumeenia",
    1,
    null
  ],
  [
    "loc_saina",
    1,
    null
  ],
  [
    "loc_seejärel",
    1,
    null
  ],
  [
    "loc_sosmondlaslannantaažija",
    1,
    null
  ],
  [
    "loc_suurbritannia",
    1,
    null
  ],
  [
    "loc_tais",
    1,
    null
  ],
  [
    "loc_tallinn_helsingi",
    1,
    null
  ],
  [
    "loc_tartu_linn",
    1,
    null
  ],
  [
    "loc_toris",
    1,
    null
  ],
  [
    "loc_tõrva",
    1,
    null
  ],
  [
    "loc_tšetšeenia",
    1,
    null
  ],
  [
    "loc_valga",
    1,
    null
  ],
  [
    "loc_vilsandi_saar",
    1,
    null
  ],
  [
    "loc_vormsi",
    1,
    null
  ],
  [
    "loc_vääna",
    1,
    null
  ],
  [
    "loc_ärgoit",
    1,
    null
  ],
  [
    "loc_afganistan",
    1,
    null
  ],
  [
    "loc_armeenia",
    1,
    null
  ],
  [
    "loc_california",
    1,
    null
  ],
  [
    "loc_džaul",
    1,
    null
  ],
  [
    "loc_eesti_nsv",
    1,
    null
  ],
  [
    "loc_elysee",
    1,
    null
  ],
  [
    "loc_estonian",
    1,
    null
  ],
  [
    "loc_gazprom",
    1,
    null
  ],
  [
    "loc_haapsald",
    1,
    null
  ],
  [
    "loc_hiiumaa",
    1,
    null
  ],
  [
    "loc_ida-euroopa",
    1,
    null
  ],
  [
    "loc_indiaan",
    1,
    null
  ],
  [
    "loc_iraan",
    1,
    null
  ],
  [
    "loc_kaks",
    1,
    null
  ],
  [
    "loc_kiviõli",
    1,
    null
  ],
  [
    "loc_kõrval",
    1,
    null
  ],
  [
    "loc_kuusald",
    1,
    null
  ],
  [
    "loc_lavka",
    1,
    null
  ],
  [
    "loc_liibüa",
    1,
    null
  ],
  [
    "loc_lubama",
    1,
    null
  ],
  [
    "loc_maroko",
    1,
    null
  ],
  [
    "loc_mehhiko",
    1,
    null
  ],
  [
    "loc_minsk",
    1,
    null
  ],
  [
    "loc_must_meri",
    1,
    null
  ],
  [
    "loc_odessa",
    1,
    null
  ],
  [
    "loc_pika_hermanni",
    1,
    null
  ],
  [
    "loc_põltsamaa",
    1,
    null
  ],
  [
    "loc_rooma",
    1,
    null
  ],
  [
    "loc_räpina",
    1,
    null
  ],
  [
    "loc_sakala",
    1,
    null
  ],
  [
    "loc_stockholm",
    1,
    null
  ],
  [
    "loc_tapa",
    1,
    null
  ],
  [
    "loc_tema",
    1,
    null
  ],
  [
    "loc_torn",
    1,
    null
  ],
  [
    "loc_tosso",
    1,
    null
  ],
  [
    "loc_ukraina",
    1,
    null
  ],
  [
    "loc_valgusmaa",
    1,
    null
  ],
  [
    "loc_vigala",
    1,
    null
  ],
  [
    "loc_virtsu",
    1,
    null
  ],
  [
    "loc_võrtsjärv",
    1,
    null
  ],
  [
    "org_tallinnfilm",
    13,
    null
  ],
  [
    "org_tallinn",
    10,
    null
  ],
  [
    "org_tallinn_film",
    7,
    null
  ],
  [
    "org_eesti",
    7,
    null
  ],
  [
    "org_tartu_ülikool",
    6,
    null
  ],
  [
    "org_tallinna_ülikool",
    5,
    null
  ],
  [
    "org_eesti_televisioon",
    4,
    null
  ],
  [
    "org_err",
    3,
    null
  ],
  [
    "org_eesti_film",
    3,
    null
  ],
  [
    "org_estonia",
    3,
    null
  ],
  [
    "org_eesti_filmi_instituut",
    2,
    null
  ],
  [
    "org_raadio_kaks",
    2,
    null
  ],
  [
    "org_rimi",
    2,
    null
  ],
  [
    "org_twitter",
    2,
    null
  ],
  [
    "org_eesti_valitsus",
    2,
    null
  ],
  [
    "org_etv",
    2,
    null
  ],
  [
    "org_instagram",
    2,
    null
  ],
  [
    "org_eesti_raadio",
    2,
    null
  ],
  [
    "org_westholmi_gümnaasium",
    2,
    null
  ],
  [
    "org_bfm",
    2,
    null
  ],
  [
    "org_peda",
    2,
    null
  ],
  [
    "org_baumani_tehas",
    1,
    null
  ],
  [
    "org_coca-cola",
    1,
    null
  ],
  [
    "org_diplomaatia",
    1,
    null
  ],
  [
    "org_elisa",
    1,
    null
  ],
  [
    "org_ep",
    1,
    null
  ],
  [
    "org_estonian_saar",
    1,
    null
  ],
  [
    "org_gpu",
    1,
    null
  ],
  [
    "org_ilumäe_kolhoos",
    1,
    null
  ],
  [
    "org_kihnu_kool",
    1,
    null
  ],
  [
    "org_kreml",
    1,
    null
  ],
  [
    "org_lihula_vallavalitsus",
    1,
    null
  ],
  [
    "org_maaleht",
    1,
    null
  ],
  [
    "org_moskva_televisioon",
    1,
    null
  ],
  [
    "org_nato",
    1,
    null
  ],
  [
    "org_pirita_klooster",
    1,
    null
  ],
  [
    "org_päevaleht",
    1,
    null
  ],
  [
    "org_tallinna_kinostuudio",
    1,
    null
  ],
  [
    "org_tallinna_sidekool",
    1,
    null
  ],
  [
    "org_teaduste_akadeemia",
    1,
    null
  ],
  [
    "org_vene_sõjavägi",
    1,
    null
  ],
  [
    "org_volkswagen",
    1,
    null
  ],
  [
    "org_bbc_surnalistika",
    1,
    null
  ],
  [
    "org_coop_pank",
    1,
    null
  ],
  [
    "org_eeeffi",
    1,
    null
  ],
  [
    "org_eesti_kinokomitee",
    1,
    null
  ],
  [
    "org_elo_rand",
    1,
    null
  ],
  [
    "org_haapsalu_kirik",
    1,
    null
  ],
  [
    "org_kik",
    1,
    null
  ],
  [
    "org_kunstiteos",
    1,
    null
  ],
  [
    "org_liivimaa_ord",
    1,
    null
  ],
  [
    "org_metsküla_kool",
    1,
    null
  ],
  [
    "org_ms",
    1,
    null
  ],
  [
    "org_nordea",
    1,
    null
  ],
  [
    "org_pirita_open",
    1,
    null
  ],
  [
    "org_pärnu_lade",
    1,
    null
  ],
  [
    "org_raasiku_haigla",
    1,
    null
  ],
  [
    "org_soome_kompartei",
    1,
    null
  ],
  [
    "org_tallinna_kaarli_kirik",
    1,
    null
  ],
  [
    "org_tallinna_linnavalitsus",
    1,
    null
  ],
  [
    "org_tallinna_tallinn_akadeemia",
    1,
    null
  ],
  [
    "org_top",
    1,
    null
  ],
  [
    "org_türi_keskkool",
    1,
    null
  ],
  [
    "org_vigala_maarja",
    1,
    null
  ],
  [
    "org_väimela_tehnikum",
    1,
    null
  ],
  [
    "org_belgia_ühiskond",
    1,
    null
  ],
  [
    "org_cv-online",
    1,
    null
  ],
  [
    "org_eka",
    1,
    null
  ],
  [
    "org_emex",
    1,
    null
  ],
  [
    "org_erso",
    1,
    null
  ],
  [
    "org_euroopa_kino",
    1,
    null
  ],
  [
    "org_hiv",
    1,
    null
  ],
  [
    "org_kaitseliit",
    1,
    null
  ],
  [
    "org_kirjanike_liit",
    1,
    null
  ],
  [
    "org_laagri_kool",
    1,
    null
  ],
  [
    "org_line",
    1,
    null
  ],
  [
    "org_montaaž",
    1,
    null
  ],
  [
    "org_mustpeade_maja",
    1,
    null
  ],
  [
    "org_õhtuleht",
    1,
    null
  ],
  [
    "org_politseiprefektuur",
    1,
    null
  ],
  [
    "org_pärnu_muuseum",
    1,
    null
  ],
  [
    "org_rahvusooper_estonia",
    1,
    null
  ],
  [
    "org_stockholmi_tehnikainstituut",
    1,
    null
  ],
  [
    "org_tallinna_kesklinna_valitsus",
    1,
    null
  ],
  [
    "org_tallinna_reaalkool",
    1,
    null
  ],
  [
    "org_tallinna_tehnikaülikool",
    1,
    null
  ],
  [
    "org_tartu",
    1,
    null
  ],
  [
    "org_tular",
    1,
    null
  ],
  [
    "org_valgus",
    1,
    null
  ],
  [
    "org_vigala_maarja_kogudus",
    1,
    null
  ],
  [
    "org_danske_pank",
    1,
    null
  ],
  [
    "org_eesti_telefilm",
    1,
    null
  ],
  [
    "org_ekn",
    1,
    null
  ],
  [
    "org_emp",
    1,
    null
  ],
  [
    "org_euroopa_liit",
    1,
    null
  ],
  [
    "org_hong_travel",
    1,
    null
  ],
  [
    "org_kaks",
    1,
    null
  ],
  [
    "org_kolga_kool",
    1,
    null
  ],
  [
    "org_lihula_kool",
    1,
    null
  ],
  [
    "org_lutsukomm",
    1,
    null
  ],
  [
    "org_moskva_kinokool",
    1,
    null
  ],
  [
    "org_napol",
    1,
    null
  ],
  [
    "org_pro",
    1,
    null
  ],
  [
    "org_pöff",
    1,
    null
  ],
  [
    "org_rakvere_tarbijate",
    1,
    null
  ],
  [
    "org_tallink",
    1,
    null
  ],
  [
    "org_tallinna_kino",
    1,
    null
  ],
  [
    "org_tallinna_riiklik",
    1,
    null
  ],
  [
    "org_tulevik",
    1,
    null
  ],
  [
    "org_vangla",
    1,
    null
  ],
  [
    "org_viljandi_kultuuriakadeemia",
    1,
    null
  ],
  [
    "org_ülemiste_keskus",
    1,
    null
  ],
  [
    "per_maria",
    7,
    null
  ],
  [
    "per_karl",
    6,
    null
  ],
  [
    "per_paul",
    5,
    null
  ],
  [
    "per_jeesus",
    4,
    null
  ],
  [
    "per_johannes",
    4,
    null
  ],
  [
    "per_andrei",
    4,
    null
  ],
  [
    "per_harry",
    4,
    null
  ],
  [
    "per_maarja",
    4,
    null
  ],
  [
    "per_mark_soosaar",
    4,
    null
  ],
  [
    "per_alex",
    3,
    null
  ],
  [
    "per_laura",
    3,
    null
  ],
  [
    "per_leida_laius",
    3,
    null
  ],
  [
    "per_mark",
    3,
    null
  ],
  [
    "per_peeter_tooming",
    3,
    null
  ],
  [
    "per_ise",
    2,
    null
  ],
  [
    "per_kaspar",
    2,
    null
  ],
  [
    "per_mart_otsa",
    2,
    null
  ],
  [
    "per_sõber",
    2,
    null
  ],
  [
    "per_andres_sööt",
    2,
    null
  ],
  [
    "per_jakob",
    2,
    null
  ],
  [
    "per_sofi",
    2,
    null
  ],
  [
    "per_valeria_anderson",
    2,
    null
  ],
  [
    "per_anton",
    2,
    null
  ],
  [
    "per_arvo_iho",
    2,
    null
  ],
  [
    "per_mait_mäekivi",
    2,
    null
  ],
  [
    "per_mati_kask",
    2,
    null
  ],
  [
    "per_taivo_denso",
    2,
    null
  ],
  [
    "per_aleksander",
    2,
    null
  ],
  [
    "per_barbara",
    2,
    null
  ],
  [
    "per_kaljo_kiisk",
    2,
    null
  ],
  [
    "per_kelly",
    2,
    null
  ],
  [
    "per_marie",
    2,
    null
  ],
  [
    "per_mati_unt",
    2,
    null
  ],
  [
    "per_olema",
    2,
    null
  ],
  [
    "per_peetrus",
    2,
    null
  ],
  [
    "per_andrese",
    2,
    null
  ],
  [
    "per_härra_baumann",
    1,
    null
  ],
  [
    "per_jaak_aus",
    1,
    null
  ],
  [
    "per_jaan_tätte",
    1,
    null
  ],
  [
    "per_jeesu",
    1,
    null
  ],
  [
    "per_joachter",
    1,
    null
  ],
  [
    "per_joonas_loit",
    1,
    null
  ],
  [
    "per_jumala_raids",
    1,
    null
  ],
  [
    "per_jüri_mängufilm",
    1,
    null
  ],
  [
    "per_jäär",
    1,
    null
  ],
  [
    "per_kadina",
    1,
    null
  ],
  [
    "per_kaido",
    1,
    null
  ],
  [
    "per_kalmer_tennosaar",
    1,
    null
  ],
  [
    "per_kerdama",
    1,
    null
  ],
  [
    "per_kimi_räikkönen",
    1,
    null
  ],
  [
    "per_kolli_sten",
    1,
    null
  ],
  [
    "per_kristel_aaslaid",
    1,
    null
  ],
  [
    "per_kukkonde",
    1,
    null
  ],
  [
    "per_langipar",
    1,
    null
  ],
  [
    "per_lesk",
    1,
    null
  ],
  [
    "per_linda_rummo",
    1,
    null
  ],
  [
    "per_luitsa",
    1,
    null
  ],
  [
    "per_madis_veldman",
    1,
    null
  ],
  [
    "per_manto",
    1,
    null
  ],
  [
    "per_mari-liis",
    1,
    null
  ],
  [
    "per_maria_ardo",
    1,
    null
  ],
  [
    "per_marika_reintam",
    1,
    null
  ],
  [
    "per_martin_helme",
    1,
    null
  ],
  [
    "per_mattias_naan",
    1,
    null
  ],
  [
    "per_metsvinthall",
    1,
    null
  ],
  [
    "per_mikko_mägi",
    1,
    null
  ],
  [
    "per_mirtel_pohla",
    1,
    null
  ],
  [
    "per_murrs",
    1,
    null
  ],
  [
    "per_nikita_sergejevitš",
    1,
    null
  ],
  [
    "per_nõmmi",
    1,
    null
  ],
  [
    "per_orparvate",
    1,
    null
  ],
  [
    "per_paul-eerik_rummo",
    1,
    null
  ],
  [
    "per_peedu_ojamaa",
    1,
    null
  ],
  [
    "per_piia_frous",
    1,
    null
  ],
  [
    "per_porno",
    1,
    null
  ],
  [
    "per_pušk",
    1,
    null
  ],
  [
    "per_raimond_kolga",
    1,
    null
  ],
  [
    "per_rando_pettai",
    1,
    null
  ],
  [
    "per_reili_saar",
    1,
    null
  ],
  [
    "per_rein_maran",
    1,
    null
  ],
  [
    "per_rene_morr",
    1,
    null
  ],
  [
    "per_riinot",
    1,
    null
  ],
  [
    "per_roger",
    1,
    null
  ],
  [
    "per_rummu_jüri",
    1,
    null
  ],
  [
    "per_saara",
    1,
    null
  ],
  [
    "per_shell",
    1,
    null
  ],
  [
    "per_sulev_mäeltsemees",
    1,
    null
  ],
  [
    "per_tanel",
    1,
    null
  ],
  [
    "per_tema",
    1,
    null
  ],
  [
    "per_tiiu",
    1,
    null
  ],
  [
    "per_tõnis_kask",
    1,
    null
  ],
  [
    "per_torove",
    1,
    null
  ],
  [
    "per_tuuli_rand",
    1,
    null
  ],
  [
    "per_urmas_tamm",
    1,
    null
  ],
  [
    "per_vaisse",
    1,
    null
  ],
  [
    "per_valentin_kuik",
    1,
    null
  ],
  [
    "per_viive_leol",
    1,
    null
  ],
  [
    "per_vladimir_luts",
    1,
    null
  ],
  [
    "per_walter",
    1,
    null
  ],
  [
    "per_šamaan",
    1,
    null
  ],
  [
    "per_aabel",
    1,
    null
  ],
  [
    "per_ago_ruus",
    1,
    null
  ],
  [
    "per_albert_hermann",
    1,
    null
  ],
  [
    "per_andrus_stop",
    1,
    null
  ],
  [
    "per_anspartal",
    1,
    null
  ],
  [
    "per_ants_jõgi",
    1,
    null
  ],
  [
    "per_artra",
    1,
    null
  ],
  [
    "per_august_tsirk",
    1,
    null
  ],
  [
    "per_berg",
    1,
    null
  ],
  [
    "per_birmakera",
    1,
    null
  ],
  [
    "per_carl_juunior",
    1,
    null
  ],
  [
    "per_czukai",
    1,
    null
  ],
  [
    "per_dior",
    1,
    null
  ],
  [
    "per_edgar_savisaar",
    1,
    null
  ],
  [
    "per_edward_munk",
    1,
    null
  ],
  [
    "per_eerik_roosta",
    1,
    null
  ],
  [
    "per_eino_parss",
    1,
    null
  ],
  [
    "per_emil_rutiku",
    1,
    null
  ],
  [
    "per_enn_olev",
    1,
    null
  ],
  [
    "per_evald_hermaküla",
    1,
    null
  ],
  [
    "per_gabriella_farrita",
    1,
    null
  ],
  [
    "per_halleib",
    1,
    null
  ],
  [
    "per_harakas",
    1,
    null
  ],
  [
    "per_hasart",
    1,
    null
  ],
  [
    "per_helen_raivo",
    1,
    null
  ],
  [
    "per_herbert_tul",
    1,
    null
  ],
  [
    "per_ilter",
    1,
    null
  ],
  [
    "per_ivandratšov",
    1,
    null
  ],
  [
    "per_jaan_kolbr",
    1,
    null
  ],
  [
    "per_joosep_kristjan",
    1,
    null
  ],
  [
    "per_jürgen_ligi",
    1,
    null
  ],
  [
    "per_jüri_saar",
    1,
    null
  ],
  [
    "per_kaamer",
    1,
    null
  ],
  [
    "per_kadi_mats",
    1,
    null
  ],
  [
    "per_kaisa_laos",
    1,
    null
  ],
  [
    "per_kapler",
    1,
    null
  ],
  [
    "per_katorajad",
    1,
    null
  ],
  [
    "per_kihvt",
    1,
    null
  ],
  [
    "per_kingsepa",
    1,
    null
  ],
  [
    "per_konstantin_päts",
    1,
    null
  ],
  [
    "per_kristiina",
    1,
    null
  ],
  [
    "per_kuskil",
    1,
    null
  ],
  [
    "per_lietuvos",
    1,
    null
  ],
  [
    "per_loll",
    1,
    null
  ],
  [
    "per_luther_mattiisen",
    1,
    null
  ],
  [
    "per_maimi_kilm",
    1,
    null
  ],
  [
    "per_maretskaja",
    1,
    null
  ],
  [
    "per_mari-liis_jakobson",
    1,
    null
  ],
  [
    "per_maria_laidoner",
    1,
    null
  ],
  [
    "per_mari_tamm",
    1,
    null
  ],
  [
    "per_mart_helme",
    1,
    null
  ],
  [
    "per_mart_siimann",
    1,
    null
  ],
  [
    "per_mcip",
    1,
    null
  ],
  [
    "per_mia",
    1,
    null
  ],
  [
    "per_mikkus",
    1,
    null
  ],
  [
    "per_mirty",
    1,
    null
  ],
  [
    "per_mäkidet",
    1,
    null
  ],
  [
    "per_nikolai",
    1,
    null
  ],
  [
    "per_nornio",
    1,
    null
  ],
  [
    "per_otto",
    1,
    null
  ],
  [
    "per_paul_mattiisen",
    1,
    null
  ],
  [
    "per_peeter_simm",
    1,
    null
  ],
  [
    "per_piia_roosi",
    1,
    null
  ],
  [
    "per_pornovideode",
    1,
    null
  ],
  [
    "per_pärnika",
    1,
    null
  ],
  [
    "per_raimond_tamm",
    1,
    null
  ],
  [
    "per_regina",
    1,
    null
  ],
  [
    "per_reinhold_rotermanni",
    1,
    null
  ],
  [
    "per_rein_raamat",
    1,
    null
  ],
  [
    "per_rene_puura",
    1,
    null
  ],
  [
    "per_risto_puri",
    1,
    null
  ],
  [
    "per_roland_saagravu",
    1,
    null
  ],
  [
    "per_räägi-rääk",
    1,
    null
  ],
  [
    "per_sander_mölder",
    1,
    null
  ],
  [
    "per_siiri_oviir",
    1,
    null
  ],
  [
    "per_sünge",
    1,
    null
  ],
  [
    "per_tapport",
    1,
    null
  ],
  [
    "per_tenkeš",
    1,
    null
  ],
  [
    "per_timbuling",
    1,
    null
  ],
  [
    "per_tõnu_naissoo",
    1,
    null
  ],
  [
    "per_tuul",
    1,
    null
  ],
  [
    "per_tšekki",
    1,
    null
  ],
  [
    "per_urvaka",
    1,
    null
  ],
  [
    "per_valdemar",
    1,
    null
  ],
  [
    "per_viivi_luik",
    1,
    null
  ],
  [
    "per_vladimir_parvel",
    1,
    null
  ],
  [
    "per_william",
    1,
    null
  ],
  [
    "per_aare_tilk",
    1,
    null
  ],
  [
    "per_aino_ene",
    1,
    null
  ],
  [
    "per_albert_tuganov",
    1,
    null
  ],
  [
    "per_andruse",
    1,
    null
  ],
  [
    "per_animal",
    1,
    null
  ],
  [
    "per_ants_kaljurand",
    1,
    null
  ],
  [
    "per_bach",
    1,
    null
  ],
  [
    "per_bernard_kangro",
    1,
    null
  ],
  [
    "per_brunoga",
    1,
    null
  ],
  [
    "per_chardonnay",
    1,
    null
  ],
  [
    "per_daša_otto",
    1,
    null
  ],
  [
    "per_dmitri",
    1,
    null
  ],
  [
    "per_eduard_grenzstein",
    1,
    null
  ],
  [
    "per_eeriku",
    1,
    null
  ],
  [
    "per_eeva_brown",
    1,
    null
  ],
  [
    "per_elephants",
    1,
    null
  ],
  [
    "per_endel_pärn",
    1,
    null
  ],
  [
    "per_erikurat",
    1,
    null
  ],
  [
    "per_eve_kivi",
    1,
    null
  ],
  [
    "per_grete_kaljuste",
    1,
    null
  ],
  [
    "per_hannes_kaljujärv",
    1,
    null
  ],
  [
    "per_heiki_ernits",
    1,
    null
  ],
  [
    "per_helen_vinogradov",
    1,
    null
  ],
  [
    "per_herbert_tulp",
    1,
    null
  ],
  [
    "per_ingrid_ing",
    1,
    null
  ],
  [
    "per_ivan_puunima",
    1,
    null
  ],
  [
    "per_jaan_tasa",
    1,
    null
  ],
  [
    "per_janno_pipathanka",
    1,
    null
  ],
  [
    "per_jekaterina_winaagratskaja",
    1,
    null
  ],
  [
    "per_johannes_vares-barbarus",
    1,
    null
  ],
  [
    "per_joosep_tamm",
    1,
    null
  ],
  [
    "per_jüril",
    1,
    null
  ],
  [
    "per_jüri_sillart",
    1,
    null
  ],
  [
    "per_kaamera",
    1,
    null
  ],
  [
    "per_kadri_kanter",
    1,
    null
  ],
  [
    "per_kalfi",
    1,
    null
  ],
  [
    "per_kaur_mägi",
    1,
    null
  ],
  [
    "per_kilekott",
    1,
    null
  ],
  [
    "per_kino",
    1,
    null
  ],
  [
    "per_kõrboja",
    1,
    null
  ],
  [
    "per_kristjan_mari",
    1,
    null
  ],
  [
    "per_kuskilt",
    1,
    null
  ],
  [
    "per_lietuvos_sostame",
    1,
    null
  ],
  [
    "per_loolaiper",
    1,
    null
  ],
  [
    "per_maalit",
    1,
    null
  ],
  [
    "per_maretzca",
    1,
    null
  ],
  [
    "per_maria_norman",
    1,
    null
  ],
  [
    "per_mart_kessel",
    1,
    null
  ],
  [
    "per_meelis_loovere",
    1,
    null
  ],
  [
    "per_michael_martin",
    1,
    null
  ],
  [
    "per_mikk_rand",
    1,
    null
  ],
  [
    "per_mitta_aleksander",
    1,
    null
  ],
  [
    "per_naatsaret",
    1,
    null
  ],
  [
    "per_nipernaad",
    1,
    null
  ],
  [
    "per_okova",
    1,
    null
  ],
  [
    "per_pajusti",
    1,
    null
  ],
  [
    "per_pavel_kubo",
    1,
    null
  ],
  [
    "per_pirete",
    1,
    null
  ],
  [
    "per_priit_pärn",
    1,
    null
  ],
  [
    "per_rabak",
    1,
    null
  ],
  [
    "per_rain_simmul",
    1,
    null
  ],
  [
    "per_regina_meri",
    1,
    null
  ],
  [
    "per_rein_kootu",
    1,
    null
  ],
  [
    "per_remurd",
    1,
    null
  ],
  [
    "per_revo",
    1,
    null
  ],
  [
    "per_robert_kas",
    1,
    null
  ],
  [
    "per_ron",
    1,
    null
  ],
  [
    "per_rääkima",
    1,
    null
  ],
  [
    "per_sandra",
    1,
    null
  ],
  [
    "per_siljardül",
    1,
    null
  ],
  [
    "per_stefan",
    1,
    null
  ],
  [
    "per_taylor",
    1,
    null
  ],
  [
    "per_terje_talv",
    1,
    null
  ],
  [
    "per_toivo_helme",
    1,
    null
  ],
  [
    "per_tõnu_virve",
    1,
    null
  ],
  [
    "per_tuuline",
    1,
    null
  ],
  [
    "per_uku_masing",
    1,
    null
  ],
  [
    "per_urve_palo",
    1,
    null
  ],
  [
    "per_valdemar_ist",
    1,
    null
  ],
  [
    "per_vasak",
    1,
    null
  ],
  [
    "per_virv",
    1,
    null
  ],
  [
    "per_voldemar_jänes",
    1,
    null
  ],
  [
    "per_ülo_tambek",
    1,
    null
  ],
  [
    "per_adolf_hitler",
    1,
    null
  ],
  [
    "per_aitäh",
    1,
    null
  ],
  [
    "per_andrei_tarkovski",
    1,
    null
  ],
  [
    "per_andrus_ansip",
    1,
    null
  ],
  [
    "per_anna-brita",
    1,
    null
  ],
  [
    "per_anton_hansen",
    1,
    null
  ],
  [
    "per_ants_park",
    1,
    null
  ],
  [
    "per_arvo_kukumägi",
    1,
    null
  ],
  [
    "per_betti_alver",
    1,
    null
  ],
  [
    "per_bruno_limbak",
    1,
    null
  ],
  [
    "per_children",
    1,
    null
  ],
  [
    "per_dennis_potter",
    1,
    null
  ],
  [
    "per_dmitri_mattiis",
    1,
    null
  ],
  [
    "per_edward",
    1,
    null
  ],
  [
    "per_eerik_kruus",
    1,
    null
  ],
  [
    "per_eevi_silla",
    1,
    null
  ],
  [
    "per_elite",
    1,
    null
  ],
  [
    "per_endel_rita",
    1,
    null
  ],
  [
    "per_ester_väljaots",
    1,
    null
  ],
  [
    "per_fengher",
    1,
    null
  ],
  [
    "per_grimmide",
    1,
    null
  ],
  [
    "per_hannes_võrno",
    1,
    null
  ],
  [
    "per_harry_martinson",
    1,
    null
  ],
  [
    "per_heino_pars",
    1,
    null
  ],
  [
    "per_helmi",
    1,
    null
  ],
  [
    "per_hildsoff",
    1,
    null
  ],
  [
    "per_ira",
    1,
    null
  ],
  [
    "per_ivo_linna",
    1,
    null
  ],
  [
    "per_jaan_toominga",
    1,
    null
  ],
  [
    "per_jan_uus",
    1,
    null
  ],
  [
    "per_jevgeni_hirmoonia",
    1,
    null
  ],
  [
    "per_john_jean",
    1,
    null
  ],
  [
    "per_juhan",
    1,
    null
  ],
  [
    "per_jüri_müür",
    1,
    null
  ],
  [
    "per_jüri_sillarta",
    1,
    null
  ],
  [
    "per_kaarel_kurismaa",
    1,
    null
  ],
  [
    "per_kadri_karu",
    1,
    null
  ],
  [
    "per_karl_markus",
    1,
    null
  ],
  [
    "per_kim",
    1,
    null
  ],
  [
    "per_kirill",
    1,
    null
  ],
  [
    "per_kristel_aa",
    1,
    null
  ],
  [
    "per_kristus",
    1,
    null
  ],
  [
    "per_laano",
    1,
    null
  ],
  [
    "per_leis",
    1,
    null
  ],
  [
    "per_limbul",
    1,
    null
  ],
  [
    "per_louis_kristo",
    1,
    null
  ],
  [
    "per_mait_rufe",
    1,
    null
  ],
  [
    "per_margus_tamme",
    1,
    null
  ],
  [
    "per_maria_aleksei",
    1,
    null
  ],
  [
    "per_mart_laar",
    1,
    null
  ],
  [
    "per_merle_karusoo",
    1,
    null
  ],
  [
    "per_mihkel_anna-brita",
    1,
    null
  ],
  [
    "per_mikk_sarv",
    1,
    null
  ],
  [
    "per_monika",
    1,
    null
  ],
  [
    "per_nikita_michalkov",
    1,
    null
  ],
  [
    "per_nipernaat",
    1,
    null
  ],
  [
    "per_peeaa",
    1,
    null
  ],
  [
    "per_piret_kaljuste",
    1,
    null
  ],
  [
    "per_puriood",
    1,
    null
  ],
  [
    "per_rail",
    1,
    null
  ],
  [
    "per_raivo_maria",
    1,
    null
  ],
  [
    "per_reija",
    1,
    null
  ],
  [
    "per_rein_mara",
    1,
    null
  ],
  [
    "per_rene_haljas",
    1,
    null
  ],
  [
    "per_riinat",
    1,
    null
  ],
  [
    "per_robert_kask",
    1,
    null
  ],
  [
    "per_ronaldo",
    1,
    null
  ],
  [
    "per_saagnemy",
    1,
    null
  ],
  [
    "per_sauvignon_blanc",
    1,
    null
  ],
  [
    "per_smilers",
    1,
    null
  ],
  [
    "per_sulev_keedus",
    1,
    null
  ],
  [
    "per_tamand_višnu",
    1,
    null
  ],
  [
    "per_teet_kallas",
    1,
    null
  ],
  [
    "per_tiima",
    1,
    null
  ],
  [
    "per_tom_tamme",
    1,
    null
  ],
  [
    "per_toomas_crumpa",
    1,
    null
  ],
  [
    "per_tuuli_kool",
    1,
    null
  ],
  [
    "per_uno_naissoo",
    1,
    null
  ],
  [
    "per_vadja_jürkare",
    1,
    null
  ],
  [
    "per_valentin",
    1,
    null
  ],
  [
    "per_vettumart",
    1,
    null
  ],
  [
    "per_virve_reiman",
    1,
    null
  ],
  [
    "per_vufa",
    1,
    null
  ],
  [
    "per_äkki",
    1,
    null
  ],
  [
    "per_adolf_test",
    1,
    null
  ],
  [
    "per_albert",
    1,
    null
  ],
  [
    "per_aleksei_tony",
    1,
    null
  ],
  [
    "per_andrus_paavel",
    1,
    null
  ],
  [
    "per_anne_mere",
    1,
    null
  ],
  [
    "per_anton_hansen_tammsaare",
    1,
    null
  ],
  [
    "per_arnold_luther",
    1,
    null
  ],
  [
    "per_arvo_pärt",
    1,
    null
  ],
  [
    "per_beff",
    1,
    null
  ],
  [
    "per_bhabai",
    1,
    null
  ],
  [
    "per_bruno_noppanen",
    1,
    null
  ],
  [
    "per_christopher_louis",
    1,
    null
  ],
  [
    "per_dimitri_mattiisen",
    1,
    null
  ],
  [
    "per_dmitri_mattiisen",
    1,
    null
  ],
  [
    "per_edwardi",
    1,
    null
  ],
  [
    "per_eerik_las",
    1,
    null
  ],
  [
    "per_eha_masing",
    1,
    null
  ],
  [
    "per_elo_rand",
    1,
    null
  ],
  [
    "per_endel_sven",
    1,
    null
  ],
  [
    "per_evald_aavik",
    1,
    null
  ],
  [
    "per_ferik",
    1,
    null
  ],
  [
    "per_gustav",
    1,
    null
  ],
  [
    "per_hans",
    1,
    null
  ],
  [
    "per_harry_rehe",
    1,
    null
  ],
  [
    "per_helenal",
    1,
    null
  ],
  [
    "per_hendrik_sal-saller",
    1,
    null
  ],
  [
    "per_hille_tarto",
    1,
    null
  ]
]